import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { max } from 'moment';
import Quagga from 'quagga'; // ES6
import { take } from 'rxjs/operators';
import { DropDownListDTO } from 'src/app/entity/dto/dropdownlist.component';
import { ActionMessage, TypeMessage } from 'src/app/entity/enum/enum-notification';
import { FormularioService } from 'src/app/services/formulario.service';
import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from 'src/app/services/notification.service';
import { recomendacoesCd003 } from './model/recomendacoes-cd003';

@Component({
    selector: 'app-cd003-card-guide',
    templateUrl: './cd003-card-guide.component.html',
    styleUrls: ['./cd003-card-guide.component.scss']
})
export class Cd003CardGuideComponent implements OnInit {
    public formulario?: FormGroup;
    public listRemocaoDefeitosInfo?: any[];
    public listPassadasAnteriores?: any[];

    public siteBeneficiamento?: string;
    public safra?: string;
    public equipamentosUtilizados?: string;

    public perdaBoaPrc?: any;
    public isPerdaSementesBoas: boolean = false;
    public isDefeitoMGTDetails: boolean = false;
    public isDefeitoMGTDetailsPrevia : boolean = false;

    public controleAnalise?: string;
    public numeroPassada?: number;
    public arrayPassadasReal = [];
    public arrayPassadasEstrategiaInicial = [];
    public arrayPassadasEstrategiaFinal = [];
    public arrayPassadasTabela = [];
    public objetoPrimeiraPassada = {};
    public defeitosFoco = [];

    public passadasDensimetrica = 0;
    public passadasColunaColor = 0;
    public passadasColunaColorOriginal = 0;
    public textoPassadas = '';

    public quebradasLeves?: number;
    public quebradasSeveras?: number;
    public ardidasLeves?: number;
    public ardidasSeveras?: number;
    public furadasLeves?: number;
    public furadasSeveras?: number;
    public silkCutLeves?: number;
    public silkCutSeveras?: number;
    public poppedKernelSeveras?: number;
    public poppedKernelLeves?: number;
    public inerte?: number;
    public sabugoPenduculo?: string;
    public totalDefeitos?: number;
    public resultado?: string;

    public diferencaPesoHectolitrico?: number;
    public pesoHectolitricoFracaoBoa?: number;

    public enablePrevia = false;
    public enableApprovedPrevia = false;
    public enableFuradasSeveras = false;
    public enableSilkCutSeveras = false;
    public enablePoppedKernelSeveras = false;
    public enablePoppedKernelLeves = false;
    public enableSelection = false;
    public enableDefeitosFoco = false;
    public enableTable = false;
    public enableNumeroPassagens = false;
    public enableDefeitosAcima = false;
    public enableSugestaoDensimetrica = false;
    public enableSugestaoColunaColor = false;
    public enableSugestaoIneficiente = false;
    public enableSugestaoMuitasPassadas = false;

    public enableEficiencia = false;
    public enableApprovedEfic = false;
    public enablePassadaAnteriorInexistente = false;
    public passadaAnteriorPrevia = '';

    public enableShapeText = false;
    public enableColorText = false;
    public enableColunaText = false;
    public enableMGTText = false;
    public enableErrorExists = false;
    public densimetricaPresente: boolean = false;

    public defeitoShapeText = '';
    public defeitoColorText = '';
    public defeitoColunaText = '';
    public defeitoMGTText = '';
    public defeitoMGTDetails = '';

    public numeroPassadaAnterior: number = 0;
    public isPassadaPrevia = true;

    public equipPriorityByDefeitos = [
        { name: 'quebradas_leves', priority: ['MGT', 'Color', 'Coluna'] },
        { name: 'quebradas_severas', priority: ['MGT', 'Coluna'] },
        { name: 'ardidas_leves', priority: ['Color', 'MGT', 'Coluna'] },
        { name: 'ardidas_severas', priority: ['Color', 'MGT', 'Coluna'] },
        { name: 'furadas_leves', priority: [] },
        { name: 'furadas_severas', priority: ['MGT', 'Coluna'] },
        //{ name: 'silk_cut_leves', priority: [] },
        //{ name: 'silk_cut_severas', priority: ['Color'] },
        { name: 'popped_kernel_leves', priority: [] },
        { name: 'popped_kernel_leves_cor', priority: ['Color', 'MGT'] },
        { name: 'popped_kernel_severas', priority: ['MGT', 'Coluna'] },
        { name: 'popped_kernel_severas_cor', priority: ['MGT', 'Color', 'Coluna'] },
        { name: 'popped_kernel_severas_densidade', priority: ['MGT', 'Coluna'] },
        { name: 'inerte_severas', priority: ['Coluna', 'Shape', 'MGT'] }
    ];

    public defeitosNames = {
        quebradas_leves: 'Quebradas leves',
        quebradas_severas: 'Quebradas severas',
        ardidas_leves: 'Ardidas leves',
        ardidas_severas: 'Ardidas severas',
        furadas_leves: 'Furadas leves',
        furadas_severas: 'Furadas severas',
        //silk_cut_leves: 'Silk Cut leves',
        //silk_cut_severas: 'Silk Cut severas',
        popped_kernel_leves: 'Popped Kernel leves',
        popped_kernel_leves_cor: 'Popped Kernel leves cor',
        popped_kernel_severas: 'Popped Kernel severas',
        popped_kernel_severas_cor: 'Popped Kernel severas cor',
        popped_kernel_severas_densidade: 'Popped Kernel severas densidade',
        inerte_severas: 'Inertes'
    }

    public equipNames = {
        Color: 'Color Sorter',
        Coluna: 'Coluna de Ar',
        MGT: 'Densimétrica',
        Shape: 'Shape Color Sorter'
    }

    public equipNamesTable = {
        coluna_color: 'Coluna e Color',
        densimetrica: 'Densimétrica'
    }

    public dataSource?: MatTableDataSource<any>;
    public displayedColumns?: string[] = ['numero_passada', 'equip'];

    constructor(
        protected generalService: GeneralService,
        public dialogRef: MatDialogRef<Cd003CardGuideComponent>,
        protected formularioService: FormularioService,
        protected notificationService: NotificationService,
        protected formBuilder: FormBuilder,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        this.formulario = this.formBuilder.group({
            tipo_furado: [null, []],
            tipo_silk_cut: [null, []],
            tipo_popped_kernel_leves: [null, []],
            tipo_popped_kernel_severas: [null, []],
        });
    }

    async ngOnInit(): Promise<void> {
        this.siteBeneficiamento = this.data?.siteBeneficiamento;
        this.safra = this.data?.safra;
        this.equipamentosUtilizados = this.data?.equipamentosUtilizados;

        this.controleAnalise = this.data?.controleAnalise;
        this.numeroPassada = this.data?.numeroPassada;

        this.quebradasLeves = this.data?.quebradasLeves;
        this.quebradasSeveras = this.data?.quebradasSeveras;
        this.ardidasLeves = this.data?.ardidasLeves;
        this.ardidasSeveras = this.data?.ardidasSeveras;
        this.furadasLeves = this.data?.furadasLeves;
        this.furadasSeveras = this.data?.furadasSeveras;
        this.silkCutLeves = this.data?.silkCutLeves;
        this.silkCutSeveras = this.data?.silkCutSeveras;
        this.poppedKernelSeveras = this.data?.poppedKernelSeveras;
        this.poppedKernelLeves = this.data?.poppedKernelLeves;
        this.inerte = this.data?.inerte;
        this.sabugoPenduculo = this.data?.sabugoPenduculo;
        this.totalDefeitos = this.data?.totalDefeitos;
        this.resultado = this.data?.resultado;

        this.diferencaPesoHectolitrico = this.data?.diferencaPesoHectolitrico;
        this.pesoHectolitricoFracaoBoa = this.data?.pesoHectolitricoFracaoBoa;

        this.perdaBoaPrc = this.data?.perdaBoaPrc

        await this.buildCard();
    }

    async saveSuggestion() {
        const suggestions: recomendacoesCd003[] = [];
        const created_at = new Date();
        const id: number = this.data?.cd003Id === 0 ? this.formularioService.savedResponse?.data?.id : this.data?.cd003Id as number;
        if (this.isPassadaPrevia) {
            const suggestion: recomendacoesCd003 = {
                created_at: created_at,
                controle_de_analise: this.controleAnalise.toString(),
                previa_e_numero_da_passagem: this.numeroPassada,
                numero_da_regulagem: 0,
                safra: this.safra,
                site_de_beneficiamento: this.siteBeneficiamento,
                numero_passada: this.numeroPassada.toString(),
                equipamento: 'Coluna e Color',
                quebradas_leves: this.quebradasLeves,
                quebradas_severas: this.quebradasSeveras,
                ardidas_leves: this.ardidasLeves,
                ardidas_severas: this.ardidasSeveras,
                furadas_leves: this.furadasLeves,
                furadas_severas: this.furadasSeveras,
                popped_kernel_leves: this.poppedKernelLeves,
                popped_kernel_severas: this.poppedKernelSeveras,
                silk_cut_leves: this.silkCutLeves,
                silk_cut_severos: this.silkCutSeveras,
                inerte: this.inerte,
                total_leves: this.quebradasLeves + this.ardidasLeves + this.furadasLeves + this.poppedKernelLeves + this.silkCutLeves,
                total_severas: this.quebradasSeveras + this.ardidasSeveras + this.furadasSeveras + this.poppedKernelSeveras + this.silkCutSeveras,
                total_defeitos: this.totalDefeitos,
                status: this.resultado,
                defeito_foco_da_passada: this.defeitosFoco?.map(item => item.name)?.join(', '),
                cd003_id: id
            }
            suggestions.push(suggestion);
        } else {

            for (let index = 1; index < this.dataSource.data.length; index++) {
                const passada = this.dataSource.data[index];
                const suggestion: recomendacoesCd003 = {
                    created_at: created_at,
                    controle_de_analise: this.controleAnalise?.toString(),
                    previa_e_numero_da_passagem: this.numeroPassada,
                    numero_da_regulagem: 0,
                    safra: this.safra,
                    site_de_beneficiamento: this.siteBeneficiamento,
                    numero_passada: passada.numero_passada,
                    equipamento: passada.equip,
                    quebradas_leves: passada.quebradas_leves,
                    quebradas_severas: passada.quebradas_severas,
                    ardidas_leves: passada.ardidas_leves,
                    ardidas_severas: passada.ardidas_severas,
                    furadas_leves: passada.furadas_leves,
                    furadas_severas: passada.furadas_severas,
                    popped_kernel_leves: passada.popped_kernel_leves,
                    popped_kernel_severas: passada.popped_kernel_severas,
                    silk_cut_leves: passada.silk_cut_leves,
                    silk_cut_severos: passada.silk_cut_severos,
                    inerte: passada.inerte,
                    total_leves: passada.total_leves,
                    total_severas: passada.total_severas,
                    total_defeitos: passada.defeitos_total,
                    status: passada.status,
                    defeito_foco_da_passada: passada.campos_foco?.map(item => item.name)?.join(', '),
                    cd003_id: id
                }
                suggestions.push(suggestion);
            }

            console.log(suggestions)
        }
        console.log(suggestions)
        const response = await this.formularioService.saveCd003Recomendation(suggestions);
        if (response) {

            console.log('Resposta do servidor:', response);
            this.notificationService.sendNotification('', TypeMessage.New, ActionMessage.Success);
            this.closeModal()
        }

    }

    isConditionalSite() {
        if (this.siteBeneficiamento === 'CVE' || this.siteBeneficiamento === 'ITA' || this.siteBeneficiamento === 'UDI')
            return true;
        else
            return false;
    }

    async getListPassadaAnterior(): Promise<void> {
        const filter = {
            safra: this.safra,
            site_beneficiamento: this.siteBeneficiamento,
            controle_analise_ca: this.controleAnalise
        }
        await this.formularioService.getAllFilter('cd003', { filters: filter }).pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listPassadasAnteriores = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, `Ocorreu um Erro para buscar do banco de dados para dados do cd003`);
        });
    }

    async getListRemocaoDefeitos(): Promise<void> {
        await this.formularioService.getAll('estrategia_remove_defeitos', {}).pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listRemocaoDefeitosInfo = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, `Ocorreu um Erro para buscar do banco de dados para estratégia de remoção de defeitos`);
        });
    }

    async buildCard(): Promise<void> {
        this.getAlertaRangesPerdaSementesBoas();
        // Caso a passada seja Prévia
        if (this.numeroPassada != null && this.numeroPassada === 0)
            await this.cardPrevia();
        else
            await this.cardEficiencia();
    }

    async cardPrevia(): Promise<void> {
        if (!!this.resultado && this.resultado === 'APR')
            //Se Passada for aprovada
            this.enableApprovedPrevia = true;
        else
            // Se passada for reprovada
            await this.cardPreviaReprovada();

        this.enablePrevia = true;
    }

    async cardPreviaReprovada(): Promise<void> {
        this.isPassadaPrevia = true
        await this.buildDefeitosSelect();

        if (!this.enableSelection) {
            await this.buildEstrategia();
            await this.checkTotalDefeitos();
            await this.checkDefeitosDificeis(this.arrayPassadasTabela);
        }
    }

    async checkTotalDefeitos(): Promise<void> {
        if (this.totalDefeitos > 15)
            this.enableDefeitosAcima = true;
    }

    async checkDefeitosDificeis(passadasEstrategiaFinal: Array<any>): Promise<void> {
        const tipoFurado = this.formulario.get('tipo_furado')?.value;
        const tipoSilkCut = this.formulario.get('tipo_silk_cut')?.value;
        const tipoPoppedKernelLeves = this.formulario.get('tipo_popped_kernel_leves')?.value;
        const tipoPoppedKernelSeveras = this.formulario.get('tipo_popped_kernel_severas')?.value;

        var hasFuradoLeve = false;
        var hasSilkCutLeve = false;
        var hasPoppedLeveI = false;
        var hasPoppedLeveII = false;

        if (tipoFurado != null && tipoFurado != undefined) {
            if (tipoFurado === "1") {
                hasFuradoLeve = false
            }
            else {
                hasFuradoLeve = true
            }
        }


        if (tipoSilkCut != null && tipoSilkCut != undefined) {
            if (tipoSilkCut === "1") {
                hasSilkCutLeve = false
            }
            else {
                hasSilkCutLeve = true
            }
        }


        if (tipoPoppedKernelSeveras != null && tipoPoppedKernelSeveras != undefined) {
            if (tipoPoppedKernelSeveras === "1") {
                hasPoppedLeveI = false
            }
            else {
                hasPoppedLeveI = true
            }
        }


        if (tipoPoppedKernelLeves != null && tipoPoppedKernelLeves != undefined) {
            if (tipoPoppedKernelLeves === "1") {
                hasPoppedLeveII = true
            }
            else {
                hasPoppedLeveII = false
            }
        }

        if (this.numeroPassada > 0) {
            if (this.isConditionalSite()) {
                var numeroUltimaPassadaReal = passadasEstrategiaFinal[passadasEstrategiaFinal.length - 1].passadaConditional - this.numeroPassada;
                if (numeroUltimaPassadaReal > 1
                    && (!!this.silkCutLeves || !!this.furadasLeves || hasFuradoLeve || hasSilkCutLeve || hasPoppedLeveI || hasPoppedLeveII))
                    this.enableSugestaoIneficiente = true;
            }
            else {
                var numeroUltimaPassadaReal = passadasEstrategiaFinal[passadasEstrategiaFinal.length - 1].numero_passada - this.numeroPassada;
                if (numeroUltimaPassadaReal > 1
                    && (!!this.silkCutLeves || !!this.furadasLeves || hasFuradoLeve || hasSilkCutLeve || hasPoppedLeveI || hasPoppedLeveII))
                    this.enableSugestaoIneficiente = true;
            }
        }
        else {
            if (this.isConditionalSite()) {
                var numeroUltimaPassada = passadasEstrategiaFinal[passadasEstrategiaFinal.length - 1].passadaConditional;
                if (numeroUltimaPassada > 4
                    && (!!this.silkCutLeves || !!this.furadasLeves || hasFuradoLeve || hasSilkCutLeve || hasPoppedLeveI || hasPoppedLeveII))
                    this.enableSugestaoIneficiente = true;
            }
            else {
                var numeroUltimaPassada = passadasEstrategiaFinal[passadasEstrategiaFinal.length - 1].numero_passada;
                if (numeroUltimaPassada > 4
                    && (!!this.silkCutLeves || !!this.furadasLeves || hasFuradoLeve || hasSilkCutLeve || hasPoppedLeveI || hasPoppedLeveII))
                    this.enableSugestaoIneficiente = true;
            }
        }
    }

    async buildDefeitosSelect(): Promise<void> {

        //Se possuir furados severos
        if (!!this.furadasSeveras && this.furadasSeveras > 0)
            this.enableFuradasSeveras = false;

        //Se possuir silk cut severos
        if (!!this.silkCutSeveras && this.silkCutSeveras > 0)
            this.enableSilkCutSeveras = true;

        //Se possuir popped Kernel severos
        if (!!this.poppedKernelSeveras && this.poppedKernelSeveras > 0)
            this.enablePoppedKernelSeveras = true;

        //Se possuir popped Kernel leves
        if (!!this.poppedKernelLeves && this.poppedKernelLeves > 0)
            this.enablePoppedKernelLeves = true;

        if (this.enablePoppedKernelSeveras || this.enablePoppedKernelLeves)
            this.enableSelection = true
    }

    async buscarDefeitoFoco(array: Array<any>, previaNumeroPassada: number, numeroProxPassada: number): Promise<void> {
        for(var i = 0; i < array[previaNumeroPassada].campos_foco.length; i++) {
            let defeitosFoco;
            if(array[numeroProxPassada] !== undefined && array[numeroProxPassada].equip.trim()?.toUpperCase() === "Densimétrica".trim()?.toUpperCase())
                defeitosFoco = array[previaNumeroPassada].campos_foco.filter(x => x.showEquip.trim()?.toUpperCase() === "Densimétrica".trim()?.toUpperCase());
            else
                defeitosFoco = array[previaNumeroPassada].campos_foco.filter(x => x.showEquip.trim()?.toUpperCase() !== "Densimétrica".trim()?.toUpperCase());

            this.defeitosFoco = defeitosFoco;
        }
    }

    async buildEstrategia(): Promise<void> {
        await this.getListRemocaoDefeitos();
        const firstObj = await this.createFirstLineObject();

        // Estrategia Inicial
        await this.calcularEstrategiaInicial();
        this.passadasColunaColorOriginal = this.arrayPassadasEstrategiaInicial.length - 1;

        await this.verificarSugestaoColunaColor();
        // Se possui mais de 3 Passadas calcula estrategia usando densimetrica
        if (!this.isConditionalSite() && this.arrayPassadasEstrategiaInicial.length > 4
            || this.isConditionalSite() && this.arrayPassadasEstrategiaInicial.length > 3) {
            if (!this.isConditionalSite()) {}
        }
        else {
            this.passadasColunaColor = this.arrayPassadasEstrategiaInicial.length - 1;
            this.enableNumeroPassagens = true;

            // Teste numero de passadas com densimetrica
            await this.calcularEstrategiaDensimetrica();
            if (this.arrayPassadasEstrategiaFinal.length == 2 && this.arrayPassadasEstrategiaInicial.length > 3) {
                this.enableSugestaoDensimetrica = true;
                if (this.isConditionalSite())
                    this.enableSugestaoDensimetrica = false;
            }

            this.passadasDensimetrica = 0;
            this.passadasColunaColor = this.arrayPassadasEstrategiaInicial.length - 1;

            //this.textoPassadas = this.passadasColunaColor + ' passada(s) na coluna e color.';
        }

        if (this.arrayPassadasEstrategiaInicial.length <= 4) {
            //this.textoPassadas = (this.arrayPassadasEstrategiaInicial.length - 1) + ' passada(s) na coluna e color.';
            this.arrayPassadasTabela = this.arrayPassadasEstrategiaInicial;

            // Determinar focos Iniciais
            this.buscarDefeitoFoco(this.arrayPassadasEstrategiaInicial, this.numeroPassada, this.numeroPassada+1);
            //this.defeitosFoco = this.arrayPassadasEstrategiaInicial[0].campos_foco;
        }
        else {
            var passadasInicial = this.arrayPassadasEstrategiaInicial[this.arrayPassadasEstrategiaInicial.length - 1].numero_passada;
            var passadasFinal = this.arrayPassadasEstrategiaFinal[this.arrayPassadasEstrategiaFinal.length - 1].numero_passada;

            if (this.isConditionalSite()) {
                var passadaConditional = 0;
                this.arrayPassadasEstrategiaFinal.reduce((prev, curr) => {
                    if (prev.equip === 'Coluna e Color' && curr.equip === 'Densimétrica') {
                        prev['passadaConditional'] = passadaConditional;
                        curr['passadaConditional'] = passadaConditional;
                    }
                    else {
                        prev['passadaConditional'] = passadaConditional;
                        passadaConditional++;
                        curr['passadaConditional'] = passadaConditional;
                    }
                    return curr;
                })

                passadasFinal = this.arrayPassadasEstrategiaFinal[this.arrayPassadasEstrategiaFinal.length - 1].passadaConditional;
            }

            if (passadasInicial < passadasFinal) {
                //this.textoPassadas = passadasInicial + ' passada(s) na coluna e color.';
                this.arrayPassadasTabela = this.arrayPassadasEstrategiaInicial;

                // Determinar focos Iniciais
                this.buscarDefeitoFoco(this.arrayPassadasEstrategiaInicial, this.numeroPassada, this.numeroPassada+1);
                //this.defeitosFoco = this.arrayPassadasEstrategiaInicial[0].campos_foco;

            }
            else {
                this.arrayPassadasTabela = this.arrayPassadasEstrategiaFinal;

                // Determinar focos Iniciais
                this.buscarDefeitoFoco(this.arrayPassadasEstrategiaFinal, this.numeroPassada, this.numeroPassada+1);
                //this.defeitosFoco = this.arrayPassadasEstrategiaFinal[0].campos_foco;

                if (this.isConditionalSite()) {
                    if (this.arrayPassadasEstrategiaFinal.length > 2) {
                        if (this.arrayPassadasEstrategiaFinal[1].passadaConditional === this.arrayPassadasEstrategiaFinal[2].passadaConditional)
                            this.defeitosFoco = this.arrayPassadasEstrategiaFinal[0].campos_foco.concat(this.arrayPassadasEstrategiaFinal[1].campos_foco);
                    }
                }
            }
        }

        this.displayedColumns = this.displayedColumns.concat(['leves_total', 'severas_total', 'defeitos_total']);
        this.dataSource = new MatTableDataSource(this.arrayPassadasTabela);

        this.enableTable = true;
    }

    async calcularEstrategiaInicial(): Promise<void> {
        // Calcula Estrategia apenas com Color Coluna
        var defeitosAtendemEsperado = false;
        var passadasNecessarias = 0;
        var sequencia = 1;
        var estrategiaFinal = [];

        /*while (!defeitosAtendemEsperado) {
            // Buscar Porcentagens esperadas de Remocao
            await this.getPorcentagensRemocao(this.arrayPassadasEstrategiaInicial[passadasNecessarias], 'coluna_color');

            // Calcula Valores após a passada
            this.arrayPassadasEstrategiaInicial.push(await this.getValoresPosPassada(this.arrayPassadasEstrategiaInicial[passadasNecessarias], 'coluna_color'));

            passadasNecessarias++;

            if (this.arrayPassadasEstrategiaInicial[passadasNecessarias].severas_total <= 1
                && this.arrayPassadasEstrategiaInicial[passadasNecessarias].leves_total <= 3.5
                && this.arrayPassadasEstrategiaInicial[passadasNecessarias].defeitos_total <= 3.5)
                defeitosAtendemEsperado = true

            if (passadasNecessarias > 5) {
                defeitosAtendemEsperado = true;
            }
        }*/

        while (!defeitosAtendemEsperado) {
            var estrategia = await this.verificarPassadas(this.arrayPassadasEstrategiaInicial[passadasNecessarias], sequencia);
            if (estrategia.length > 0){
                defeitosAtendemEsperado = true;
                estrategiaFinal = estrategia;
            }
            else
                sequencia++;
        }

        //await this.verificarSugestaoColunaColor();
    }

    async calcularEstrategiaDensimetrica(): Promise<void> {
        var numeroDensimetrica = 1;
        var densimetricaAtende = false;

        var defeitosAtendemEsperado = false;
        var passadasNecessarias = 0;
        var sequencia = 1;
        var estrategiaFinal = [];

        while (!defeitosAtendemEsperado) {
            var estrategia = await this.verificarPassadas(this.arrayPassadasEstrategiaFinal[passadasNecessarias], sequencia);
            if (estrategia.length > 0){
                defeitosAtendemEsperado = true;
                estrategiaFinal = estrategia;
            }
            else
                sequencia++;
        }

		if (this.arrayPassadasEstrategiaFinal.length > 4) {
			defeitosAtendemEsperado = true;
		}

        if (this.arrayPassadasEstrategiaFinal.length <= 4 || (numeroDensimetrica === passadasNecessarias && defeitosAtendemEsperado)) {
            densimetricaAtende = true;
            this.passadasDensimetrica = numeroDensimetrica;
            this.passadasColunaColor = this.arrayPassadasEstrategiaFinal.length - (numeroDensimetrica + 1);

            /*if (this.passadasColunaColor === 0)
                this.textoPassadas = this.passadasDensimetrica + ' passada(s) na densimétrica';
            else
                this.textoPassadas = this.passadasDensimetrica + ' passada(s) na densimétrica e ' + this.passadasColunaColor + ' passada(s) na coluna e color.';*/

            this.enableNumeroPassagens = true;
        }
        else {
            if (numeroDensimetrica > 4) {
                densimetricaAtende = true;
                //this.enableSugestaoMuitasPassadas = true;
            }
            else {
                this.arrayPassadasEstrategiaFinal = [];
                this.arrayPassadasEstrategiaFinal.push(Object.assign({}, this.objetoPrimeiraPassada));
                numeroDensimetrica++;
            }
        }
    }

    async calcularEstrategiaDensimetricaConditional(): Promise<void> {
        var numeroDensimetrica = 1;
        var densimetricaAtende = false;

        while (!densimetricaAtende) {
            // Calcula Estrategia apenas com Color Coluna
            var defeitosAtendemEsperado = false;
            var defeitosNaoAtendemEsperado = false;
            var passadasNecessarias = 0;
            var numeroPassadas = 0;

            while (!defeitosAtendemEsperado && !defeitosNaoAtendemEsperado) {
                if (passadasNecessarias + 1 <= numeroDensimetrica) {
                    // Buscar Porcentagens esperadas de Remocao
                    await this.getPorcentagensRemocao(this.arrayPassadasEstrategiaFinal[numeroPassadas], 'coluna_color');

                    // Calcula Valores após a passada
                    this.arrayPassadasEstrategiaFinal.push(await this.getValoresPosPassada(this.arrayPassadasEstrategiaFinal[numeroPassadas], 'coluna_color'));

                    if (this.arrayPassadasEstrategiaFinal[numeroPassadas + 1].severas_total > 1
                        || this.arrayPassadasEstrategiaFinal[numeroPassadas + 1].leves_total > 3.5
                        || this.arrayPassadasEstrategiaFinal[numeroPassadas + 1].defeitos_total > 3.5) {
                        numeroPassadas++;
                        // Buscar Porcentagens esperadas de Remocao MGT
                        //await this.getPorcentagensRemocaoDensimetrica(this.arrayPassadasEstrategiaFinal[numeroPassadas], 'densimetrica');

                        // Calcula Valores após a passada MGT
                        //this.arrayPassadasEstrategiaFinal.push(await this.getValoresPosPassada(this.arrayPassadasEstrategiaFinal[numeroPassadas], 'densimetrica'));
                    }
                }
                else {
                    // Buscar Porcentagens esperadas de Remocao
                    //await this.getPorcentagensRemocao(this.arrayPassadasEstrategiaFinal[numeroPassadas], 'coluna_color');

                    // Calcula Valores após a passada
                    //this.arrayPassadasEstrategiaFinal.push(await this.getValoresPosPassada(this.arrayPassadasEstrategiaFinal[numeroPassadas], 'coluna_color'));
                }

                passadasNecessarias++;
                numeroPassadas++;

                if (this.arrayPassadasEstrategiaFinal[numeroPassadas].severas_total <= 1
                    && this.arrayPassadasEstrategiaFinal[numeroPassadas].leves_total <= 3.5
                    && this.arrayPassadasEstrategiaFinal[numeroPassadas].defeitos_total <= 3.5)
                    defeitosAtendemEsperado = true

                if (passadasNecessarias > 4) {
                    defeitosNaoAtendemEsperado = true;
                }

            }
            if (passadasNecessarias <= 2 || (numeroDensimetrica === passadasNecessarias && defeitosAtendemEsperado)) {
                densimetricaAtende = true;
                this.passadasDensimetrica = this.arrayPassadasEstrategiaFinal.filter(x => x.equip === "Densimétrica" && x.tipo_passada == null).length;
                this.passadasColunaColor = this.arrayPassadasEstrategiaFinal.length - (numeroDensimetrica + 1);

                /*if (this.passadasColunaColor === 0)
                    this.textoPassadas = this.passadasDensimetrica + ' passada(s) na densimétrica';
                else
                    this.textoPassadas = this.passadasDensimetrica + ' passada(s) na densimétrica e ' + this.passadasColunaColor + ' passada(s) na coluna e color.';
                */
                this.enableNumeroPassagens = true;
            }
            else {
                if (numeroDensimetrica > 4) {
                    densimetricaAtende = true;
                    //this.enableSugestaoMuitasPassadas = true;
                }
                else {
                    this.arrayPassadasEstrategiaFinal = [];
                    this.arrayPassadasEstrategiaFinal.push(Object.assign({}, this.objetoPrimeiraPassada));
                    numeroDensimetrica++;
                }
            }
        }
    }

    async getCamposFoco(obj: any): Promise<Array<any>> {
        var arraySeveras = [];
        var arrayLeves = [];

        const tipoFurado = this.formulario.get('tipo_furado')?.value;
        const tipoSilkCut = this.formulario.get('tipo_silk_cut')?.value;
        const tipoPoppedKernelLeves = this.formulario.get('tipo_popped_kernel_leves')?.value;
        const tipoPoppedKernelSeveras = this.formulario.get('tipo_popped_kernel_severas')?.value;

        // Separa Leves e severos
        for (let key of Object.keys(obj)) {
            if (key.endsWith('severas')) {

                //Busca Casos Em que pessoa seleciona Severidade via Checkbox
                switch (key) {
                    case 'furadas_severas':
                        if (tipoFurado != null && tipoFurado != undefined) {
                            if (tipoFurado === "1") {
                                if (!!obj[key]) {
                                    arraySeveras.push({
                                        field: key,
                                        value: obj[key]
                                    });
                                }
                            }
                            else {
                                if (!!obj[key]) {
                                    arrayLeves.push({
                                        field: key,
                                        value: obj[key]
                                    });
                                }
                            }
                        }
                        else {
                            if (!!obj[key]) {
                                arraySeveras.push({
                                    field: key,
                                    value: obj[key]
                                });
                            }
                        }

                        break;

                    case 'silk_cut_severas':
                        if (tipoSilkCut != null && tipoSilkCut != undefined) {
                            if (tipoSilkCut === "1") {
                                if (!!obj[key]) {
                                    arraySeveras.push({
                                        field: key,
                                        value: obj[key]
                                    });
                                }
                            }
                            else {
                                if (!!obj[key]) {
                                    arrayLeves.push({
                                        field: key,
                                        value: obj[key]
                                    });
                                }
                            }
                        }
                        else {
                            if (!!obj[key]) {
                                arraySeveras.push({
                                    field: key,
                                    value: obj[key]
                                });
                            }
                        }


                        break;

                    case 'popped_kernel_severas':
                        if (tipoPoppedKernelSeveras != null && tipoPoppedKernelSeveras != undefined) {
                            if (tipoPoppedKernelSeveras === "0" || tipoPoppedKernelSeveras === "1") {
                                if (!!obj[key]) {
                                    arraySeveras.push({
                                        field: key,
                                        value: obj[key]
                                    });
                                }
                            }
                            else {
                                if (!!obj[key]) {
                                    arrayLeves.push({
                                        field: key,
                                        value: obj[key]
                                    });
                                }
                            }
                        }
                        else {
                            if (!!obj[key]) {
                                arraySeveras.push({
                                    field: key,
                                    value: obj[key]
                                });
                            }
                        }

                        break;

                    default:
                        if (!!obj[key]) {
                            arraySeveras.push({
                                field: key,
                                value: obj[key]
                            });
                        }

                        break;
                }

            }
            if (key.endsWith('leves')) {
                //Busca Casos Em que pessoa seleciona Severidade via Checkbox
                switch (key) {
                    case 'popped_kernel_leves':
                        if (tipoPoppedKernelLeves != null && tipoPoppedKernelLeves != undefined) {
                            if (tipoPoppedKernelLeves === "0" || tipoPoppedKernelLeves === "1") {
                                if (!!obj[key]) {
                                    var equip = this.equipPriorityByDefeitos.find(obj => obj.name === key);
                                    equip.priority.push('Color');

                                    arraySeveras.push({
                                        field: key,
                                        value: obj[key]
                                    });
                                }
                            }
                            else {
                                if (!!obj[key]) {
                                    arrayLeves.push({
                                        field: key,
                                        value: obj[key]
                                    });
                                }
                            }
                        }
                        else {
                            if (!!obj[key]) {
                                arrayLeves.push({
                                    field: key,
                                    value: obj[key]
                                });
                            }
                        }

                        break;

                    default:
                        if (!!obj[key]) {
                            arrayLeves.push({
                                field: key,
                                value: obj[key]
                            });
                        }

                        break;

                }
            }
        }

        // Ordena Severos
        const orderedSeveras = arraySeveras.sort((a, b) => b.value - a.value);
        // Ordena Leves
        const orderedLeves = arrayLeves.sort((a, b) => b.value - a.value);

        // Calcula total de severos
        var totalSeveras = orderedSeveras.map(a => a.value).reduce((prev, curr) => prev + curr, 0);

        // Se total de Severos maior que 0.3 prioriza severos
        if (totalSeveras > 0.3)
            var orderedfields = orderedSeveras.concat(orderedLeves);

        // Se total de Severos menor que 0.3 prioriza leves
        else
            var orderedfields = orderedLeves.concat(orderedSeveras);

        var defeitosFoco = [];
        orderedfields.forEach(field => {
            // Busca prioridade de equipamentos
            var equip = this.equipPriorityByDefeitos.find(obj => obj.name === field.field);
            var defeitoResolvido = false;
            var priority;

            if(this.densimetricaPresente)
                priority = equip.priority.filter(x => x === 'MGT' || x === 'Coluna' || x === 'Shape');
            else
                priority = equip.priority.filter(x => x !== 'MGT');

            priority.forEach(equip => {
                // Testa se Equipamento Esta sendo utilizado
                if (!!!defeitosFoco.find(obj => obj.equip === equip) && !defeitoResolvido) {
                    // Se equipamento nao esta utilizado coloca ele como foco
                    defeitosFoco.push({
                        name: field.field,
                        equip: equip,
                        showName: this.defeitosNames[field.field],
                        showEquip: this.equipNames[equip]
                    });
                    defeitoResolvido = true;
                }
            });
        })

        this.enableDefeitosFoco = true;
        return defeitosFoco;
    }


    async getCamposFocoDensimetrica(obj: any): Promise<Array<any>> {
        var arraySeveras = [];
        var arrayLeves = [];

        const tipoFurado = this.formulario.get('tipo_furado')?.value;
        const tipoSilkCut = this.formulario.get('tipo_silk_cut')?.value;
        const tipoPoppedKernelLeves = this.formulario.get('tipo_popped_kernel_leves')?.value;
        const tipoPoppedKernelSeveras = this.formulario.get('tipo_popped_kernel_severas')?.value;

        // Separa Leves e severos
        for (let key of Object.keys(obj)) {
            if (key.endsWith('severas')) {

                //Busca Casos Em que pessoa seleciona Severidade via Checkbox
                switch (key) {
                    case 'furadas_severas':
                        if (tipoFurado != null && tipoFurado != undefined) {
                            if (tipoFurado === "1") {
                                if (!!obj[key]) {
                                    arraySeveras.push({
                                        field: key,
                                        value: obj[key]
                                    });
                                }
                            }
                            else {
                                if (!!obj[key]) {
                                    arrayLeves.push({
                                        field: key,
                                        value: obj[key]
                                    });
                                }
                            }
                        }
                        else {
                            if (!!obj[key]) {
                                arraySeveras.push({
                                    field: key,
                                    value: obj[key]
                                });
                            }
                        }

                        break;

                    case 'silk_cut_severas':
                        if (tipoSilkCut != null && tipoSilkCut != undefined) {
                            if (tipoSilkCut === "1") {
                                if (!!obj[key]) {
                                    arraySeveras.push({
                                        field: key,
                                        value: obj[key]
                                    });
                                }
                            }
                            else {
                                if (!!obj[key]) {
                                    arrayLeves.push({
                                        field: key,
                                        value: obj[key]
                                    });
                                }
                            }
                        }
                        else {
                            if (!!obj[key]) {
                                arraySeveras.push({
                                    field: key,
                                    value: obj[key]
                                });
                            }
                        }

                        break;

                    case 'popped_kernel_severas':
                        if (tipoPoppedKernelSeveras != null && tipoPoppedKernelSeveras != undefined) {
                            if (tipoPoppedKernelSeveras === "1") {
                                if (!!obj[key]) {
                                    arraySeveras.push({
                                        field: key,
                                        value: obj[key]
                                    });
                                }
                            }
                            else {
                                if (!!obj[key]) {
                                    arrayLeves.push({
                                        field: key,
                                        value: obj[key]
                                    });
                                }
                            }
                        }
                        else {
                            if (!!obj[key]) {
                                arraySeveras.push({
                                    field: key,
                                    value: obj[key]
                                });
                            }
                        }

                        break;

                    default:
                        if (!!obj[key]) {
                            arraySeveras.push({
                                field: key,
                                value: obj[key]
                            });
                        }

                        break;
                }

            }
            if (key.endsWith('leves')) {
                //Busca Casos Em que pessoa seleciona Severidade via Checkbox
                switch (key) {
                    case 'popped_kernel_leves':
                        if (tipoPoppedKernelLeves != null && tipoPoppedKernelLeves != undefined) {
                            if (tipoPoppedKernelLeves === "1") {
                                if (!!obj[key]) {
                                    arraySeveras.push({
                                        field: key,
                                        value: obj[key]
                                    });
                                }
                            }
                            else {
                                if (!!obj[key]) {
                                    arrayLeves.push({
                                        field: key,
                                        value: obj[key]
                                    });
                                }
                            }
                        }
                        else {
                            if (!!obj[key]) {
                                arrayLeves.push({
                                    field: key,
                                    value: obj[key]
                                });
                            }
                        }

                        break;

                    default:
                        if (!!obj[key]) {
                            arrayLeves.push({
                                field: key,
                                value: obj[key]
                            });
                        }

                        break;

                }
            }
        }

        // Ordena Severos
        const orderedSeveras = arraySeveras.sort((a, b) => b.value - a.value);
        // Ordena Leves
        const orderedLeves = arrayLeves.sort((a, b) => b.value - a.value);

        // Calcula total de severos
        var totalSeveras = orderedSeveras.map(a => a.value).reduce((prev, curr) => prev + curr, 0);

        // Se total de Severos maior que 0.3 prioriza severos
        if (totalSeveras > 0.3)
            var orderedfields = orderedSeveras.concat(orderedLeves);

        // Se total de Severos menor que 0.3 prioriza leves
        else
            var orderedfields = orderedLeves.concat(orderedSeveras);

        var defeitosFoco = [];
        orderedfields.forEach(field => {
            // Busca prioridade de equipamentos
            var equip = this.equipPriorityByDefeitos.find(obj => obj.name === field.field);
            var defeitoResolvido = false;

            var priority = equip.priority.filter(x => x === 'MGT');

            priority.forEach(equip => {
                // Testa se Equipamento Esta sendo utilizado
                if (!!!defeitosFoco.find(obj => obj.equip === equip) && !defeitoResolvido) {
                    // Se equipamento nao esta utilizado coloca ele como foco
                    defeitosFoco.push({
                        name: field.field,
                        equip: equip,
                        showName: this.defeitosNames[field.field],
                        showEquip: this.equipNames[equip]
                    });
                    defeitoResolvido = true;
                }
            });
        })

        this.enableDefeitosFoco = true;
        return defeitosFoco;
    }

    async getPorcentagensRemocao(obj: any, equip: string): Promise<void> {
        // Definir numero da passada
        var numeroPassada = obj.numero_passada;
        if (numeroPassada + 1 > 4)
            numeroPassada = 4
        else
            numeroPassada = numeroPassada + 1;

        const defeitosFoco = await this.getCamposFoco(obj);
        obj['campos_foco'] = defeitosFoco;

        // Separa Leves e severos
        for (let key of Object.keys(obj)) {
            if (key.endsWith('severas')) {
                if (!!obj[key]) {
                    var remocaoEsperada;
                    // Campo é foco?             
                    const isFoco = defeitosFoco.find(x => x.name === key) != undefined;
                    // Busca Prc de remocao Esperada
                    remocaoEsperada = this.getSeverasValuePrc(key, numeroPassada, equip, isFoco);
                    if (remocaoEsperada == undefined)
                        remocaoEsperada = this.getSeverasValuePrc(key, numeroPassada -1, equip, isFoco);

                    // this.listRemocaoDefeitosInfo.find(elem => elem.numero_passada === numeroPassada
                    //     && elem.tipo_defeito === 'severas'
                    //     && elem.nome_defeito === key.substring(0, key.lastIndexOf("_"))
                    //     && elem.foco === isFoco
                    //     && elem.equipamento === equip);

                    if (remocaoEsperada != undefined)
                        obj[key + '_prc'] = remocaoEsperada.valor_prc;

                    if (!this.displayedColumns.includes(key))
                        this.displayedColumns.push(key);
                }
            }
            if (key.endsWith('leves')) {
                if (!!obj[key]) {
                    var remocaoEsperada;
                    // Busca Prc de remocao Esperada
                    remocaoEsperada = this.getLevesValuePrc(key, numeroPassada, equip, false);
                    if (remocaoEsperada == undefined)
                        remocaoEsperada = this.getLevesValuePrc(key, numeroPassada -1, equip, false);
                    // this.listRemocaoDefeitosInfo.find(elem => elem.numero_passada === numeroPassada
                    //     && elem.tipo_defeito === 'leves'
                    //     && elem.nome_defeito === key.substring(0, key.lastIndexOf("_"))
                    //     && elem.foco === false
                    //     && elem.equipamento === equip);

                    if (remocaoEsperada != undefined)
                        obj[key + '_prc'] = remocaoEsperada.valor_prc;

                    if (!this.displayedColumns.includes(key))
                        this.displayedColumns.push(key);
                }
            }
        }
    }

    async getPorcentagensRemocaoDensimetrica(obj: any, equip: string): Promise<void> {
        // Definir numero da passada
        var numeroPassada = obj.numero_passada;
        if (numeroPassada + 1 > 4)
            numeroPassada = 4
        else
            numeroPassada = numeroPassada + 1;

        const defeitosFoco = await this.getCamposFocoDensimetrica(obj);
        obj['campos_foco'] = defeitosFoco;

        // Separa Leves e severos
        for (let key of Object.keys(obj)) {
            if (key.endsWith('severas')) {
                if (!!obj[key]) {
                    var remocaoEsperada;
                    // Busca Prc de remocao Esperada
                    remocaoEsperada = this.getSeverasValuePrc(key, numeroPassada, equip, false);
                    if (remocaoEsperada == undefined)
                        remocaoEsperada = this.getSeverasValuePrc(key, numeroPassada -1, equip, false);

                    if (remocaoEsperada != undefined)
                        obj[key + '_prc'] = remocaoEsperada.valor_prc;

                    if (!this.displayedColumns.includes(key))
                        this.displayedColumns.push(key);
                }
            }
            if (key.endsWith('leves')) {
                if (!!obj[key]) {
                    var remocaoEsperada;
                    // Busca Prc de remocao Esperada
                    remocaoEsperada = this.getLevesValuePrc(key, numeroPassada, equip, false);
                    if (remocaoEsperada == undefined)
                        remocaoEsperada = this.getLevesValuePrc(key, numeroPassada -1, equip, false);
                    // this.listRemocaoDefeitosInfo.find(elem => elem.numero_passada === numeroPassada
                    //     && elem.tipo_defeito === 'leves'
                    //     && elem.nome_defeito === key.substring(0, key.lastIndexOf("_"))
                    //     && elem.foco === false
                    //     && elem.equipamento === equip);

                    if (remocaoEsperada != undefined)
                        obj[key + '_prc'] = remocaoEsperada.valor_prc;

                    if (!this.displayedColumns.includes(key))
                        this.displayedColumns.push(key);
                }
            }
        }
    }

    async getValoresPosPassada(objPassada: any, equip: string): Promise<any> {
        // Calcula total severas e leves
        var totalSeveras = 0;
        var totalLeves = 0;

        //Cria Objeto
        var objFinal = {};

        for (let key of Object.keys(objPassada)) {
            if (key.endsWith('severas')) {
                if (!!objPassada[key]) {
                    objFinal[key] = objPassada[key] * (1 - objPassada[key + '_prc'])
                    if (!key.startsWith('inerte'))
                        totalSeveras += objFinal[key];
                }
                else {
                    objFinal[key] = objPassada[key];
                }
            }
            if (key.endsWith('leves')) {
                if (!!objPassada[key]) {
                    objFinal[key] = objPassada[key] * (1 - objPassada[key + '_prc'])
                    totalLeves += objFinal[key];
                }
                else {
                    objFinal[key] = objPassada[key];
                }
            }
        }

        objFinal['severas_total'] = totalSeveras;
        objFinal['leves_total'] = totalLeves;
        objFinal['defeitos_total'] = totalSeveras + totalLeves;

        objFinal['remocao_prc'] = (objPassada['defeitos_total'] - objFinal['defeitos_total']) / objPassada['defeitos_total'];
        objFinal['numero_passada'] = objPassada['numero_passada'] + 1;
        objFinal['equip'] = this.equipNamesTable[equip];

        return objFinal;
    }

    async cardEficiencia(): Promise<void> {
        //Se Passada for aprovada
        if (!!this.resultado && this.resultado === 'APR')
            this.enableApprovedEfic = true;

        else {
            await this.getListPassadaAnterior();
            await this.getListRemocaoDefeitos();
            await this.buildEstrategiaPassada();
        }
        this.enableEficiencia = true;
    }

    async buildEstrategiaPassada() {
        //Pega Dados da Passada Anterior
        const listPassadaAnterior = this.listPassadasAnteriores.filter(x => x.previa_numero_passada === (this.numeroPassada - 1));

        if (!!listPassadaAnterior && listPassadaAnterior.length > 0) {
            //Pega dados da passada anterior e cria objeto da passada
            var passadaEsperadaArray = [];
            passadaEsperadaArray.push(await this.createPassadaObject(listPassadaAnterior));

            //Pega dados da passada atual e cria objeto da passada
            var passadaRealArray = [];
            passadaRealArray.push(await this.createFirstLineObject());

            //Busca equipamento selecionado
            var equipsSelecionados = this.getSelectedEquip(this.equipamentosUtilizados);

            // Calcula valores esperados
            for (const equip of equipsSelecionados) {//aqui
                if (equip.includes('densimetrica')) {
                    // Buscar Porcentagens esperadas de Remocao
                    await this.getPorcentagensRemocaoDensimetrica(passadaEsperadaArray[passadaEsperadaArray.length - 1], 'densimetrica');

                    // Calcula Valores após a passada
                    await passadaEsperadaArray.push(await this.getValoresPosPassada(passadaEsperadaArray[passadaEsperadaArray.length - 1], 'densimetrica'));
                }
                else {
                    // Buscar Porcentagens esperadas de Remocao
                    await this.getPorcentagensRemocao(passadaEsperadaArray[passadaEsperadaArray.length - 1], 'coluna_color');

                    // Calcula Valores após a passada
                    await passadaEsperadaArray.push(await this.getValoresPosPassada(passadaEsperadaArray[passadaEsperadaArray.length - 1], 'coluna_color'));
                }
            }

            var camposFoco = [];
            // Busca campos focos
            passadaEsperadaArray.forEach(passada => {
                if (!!passada['campos_foco'] && passada['campos_foco'].length > 0) {
                    passada['campos_foco'].forEach(foco => {
                        camposFoco.push(Object.assign({}, foco));
                    })
                }
            });

            //Compara valores reais com valores esperados para os focos
            this.comparaRealEsperadoByFoco(passadaEsperadaArray[passadaEsperadaArray.length - 1], passadaRealArray[passadaRealArray.length - 1], camposFoco);
        }
        else {
            // Caso nao tenha informacoes da passada anterior
            this.enablePassadaAnteriorInexistente = true;
            if (this.numeroPassada === 1)
                this.passadaAnteriorPrevia = 'prévia';
            else
                this.passadaAnteriorPrevia = 'anterior';
        }

        this.getAlertaDiferencaPesoHectolitrico();
    }

    async createPassadaObject(arrayPassadasNumero: Array<any>): Promise<any> {
        //Cria Objeto
        var objPassada = {
            numero_passada: arrayPassadasNumero[0].previa_numero_passada,
            quebradas_leves: this.getAverage('quebradas_g', arrayPassadasNumero),
            quebradas_severas: this.getAverage('quebradas_severas_g', arrayPassadasNumero),
            ardidas_leves: this.getAverage('ardidas_g', arrayPassadasNumero),
            ardidas_severas: this.getAverage('ardidas_severas_g', arrayPassadasNumero),
            furadas_leves: this.getAverage('furadas_leves_g', arrayPassadasNumero),
            furadas_severas: this.getAverage('furadas_severas_g', arrayPassadasNumero),
            silk_cut_leves: this.getAverage('silk_cut_g', arrayPassadasNumero),
            silk_cut_severas: this.getAverage('silk_cut_severas_g', arrayPassadasNumero),
            popped_kernel_leves: this.getAverage('popped_kernel_g', arrayPassadasNumero),
            popped_kernel_severas: this.getAverage('popped_kernel_severas_g', arrayPassadasNumero),
            inerte_severas: this.getAverage('inerte_g', arrayPassadasNumero),
            equip: this.equipNamesTable[this.getSelectedEquip(arrayPassadasNumero[0].equipamentos_utilizados)[0]]
        }

        // Calcula total severas e leves
        var totalSeveras = 0;
        var totalLeves = 0;

        for (let key of Object.keys(objPassada)) {
            if (key.endsWith('severas') && !key.startsWith('inerte')) {
                if (!!objPassada[key]) {
                    totalSeveras += objPassada[key];
                }
            }
            if (key.endsWith('leves')) {
                if (!!objPassada[key]) {
                    totalLeves += objPassada[key];
                }
            }
        }

        objPassada['severas_total'] = totalSeveras;
        objPassada['leves_total'] = totalLeves;
        objPassada['defeitos_total'] = totalLeves + totalSeveras;

        this.arrayPassadasEstrategiaInicial.push(Object.assign({}, objPassada));
        this.arrayPassadasEstrategiaFinal.push(Object.assign({}, objPassada));
        this.objetoPrimeiraPassada = Object.assign({}, objPassada);

        return objPassada;
    }

    async closeModal(): Promise<void> {
        this.dialogRef.close();
    }

    async selectCheck(isPrevia: boolean): Promise<void> {
        const tipoFurado: number = 1;//this.formulario.get('tipo_furado')?.value as number;
        const tipoSilkCut: number = this.formulario.get('tipo_silk_cut')?.value as number;
        const tipoPoppedKernelLeves: number = this.formulario.get('tipo_popped_kernel_leves')?.value as number;
        const tipoPoppedKernelSeveras: number = this.formulario.get('tipo_popped_kernel_severas')?.value as number;

        if (((tipoFurado !== null && this.enableFuradasSeveras) || !this.enableFuradasSeveras)
            && ((tipoSilkCut !== null && this.enableSilkCutSeveras) || !this.enableSilkCutSeveras)
            && ((tipoPoppedKernelSeveras !== null && this.enablePoppedKernelSeveras) || !this.enablePoppedKernelSeveras)
            && ((tipoPoppedKernelLeves !== null && this.poppedKernelLeves) || !this.poppedKernelLeves)
        ) {
            if (isPrevia) {
                this.enableSelection = false;
                await this.buildEstrategia();
                await this.checkTotalDefeitos();
                await this.checkDefeitosDificeis(this.arrayPassadasTabela);
            }
            else {
                this.enableSelection = false;
                this.rebuildEstrategiaPassada();

            }
        }
    }

    async rebuildEstrategia(): Promise<void> {
        this.isPassadaPrevia = false;
        this.enableEficiencia = false;
        this.enablePrevia = true;

        await this.buildDefeitosSelect();

        if (!this.enableSelection) {
            this.rebuildEstrategiaPassada();
        }
    }

    async rebuildEstrategiaPassada() {
        this.arrayPassadasReal = [];

        // Para cada passada anterior
        for (let passada = 0; passada < this.numeroPassada; passada++) {
            //Pega Dados da Passada Anterior
            const listPassadaAnterior = this.listPassadasAnteriores.filter(x => x.previa_numero_passada === passada);

            if (!!listPassadaAnterior && listPassadaAnterior.length > 0) {
                //Pega dados da passada anterior e cria objeto da passada
                this.arrayPassadasReal.push(await this.createPassadaObject(listPassadaAnterior));
            }
            else {
                this.arrayPassadasReal.push({
                    numero_passada: passada
                })
            }
        }

        //Pega dados da passada atual e cria objeto da passada
        var objPassadaAtual = await this.createFirstLineObject()
        //Busca Equip Selecionado
        objPassadaAtual['equip'] = this.equipNamesTable[this.getSelectedEquip(this.equipamentosUtilizados)[0]];
        this.arrayPassadasReal.push(objPassadaAtual);


        //Utiliza valores da previa para calcular estrategia esperada
        this.arrayPassadasEstrategiaInicial = [];
        this.arrayPassadasEstrategiaInicial.push(Object.assign({}, this.arrayPassadasReal[0]));
        this.arrayPassadasEstrategiaFinal = [];
        this.arrayPassadasEstrategiaFinal.push(Object.assign({}, this.arrayPassadasReal[0]));

        //Recalcula estrategia esperada
        await this.rebuildEstrategiaEsperada();

        //Constrói array com valores da passada Real
        var tabelaFinal = [];
        var passadas = [];

        for (let passada = 0; passada < this.arrayPassadasReal.length; passada++) {
            if (this.arrayPassadasReal[passada] != null) {
                if (passada === this.arrayPassadasReal.length - 1) {
                   this.arrayPassadasReal[passada]['tipo_passada'] = 'atual';
                   if(this.equipamentosUtilizados.trim()?.toUpperCase() == "Coluna-Color1".trim()?.toUpperCase() || this.equipamentosUtilizados.trim()?.toUpperCase() == "Coluna-Color2".trim()?.toUpperCase() ||
                    this.equipamentosUtilizados.trim()?.toUpperCase() == "Coluna1".trim()?.toUpperCase() || this.equipamentosUtilizados.trim()?.toUpperCase() == "Coluna2".trim()?.toUpperCase())
                        this.arrayPassadasReal[passada]['equip'] = "Coluna e Color";
                    else if (this.equipamentosUtilizados = "")
                        this.arrayPassadasReal[passada]['equip'] = "";
                    else 
                        this.arrayPassadasReal[passada]['equip'] = "Densimétrica";
                }            
                else
                    this.arrayPassadasReal[passada]['tipo_passada'] = 'real';

                tabelaFinal.push(Object.assign({}, this.arrayPassadasReal[passada]));
            }
        }

        tabelaFinal.pop();

        //Recalcula estrategia futura a partir da passada atual
        tabelaFinal = tabelaFinal.concat(await this.buildEstrategiaFutura(objPassadaAtual));

        await this.checkTotalDefeitos();
        await this.checkDefeitosDificeis(tabelaFinal);
        this.arrayPassadasEstrategiaFinal.shift();
        passadas = tabelaFinal.concat(this.arrayPassadasEstrategiaFinal);  
        passadas[0]['equip'] = '';

        this.displayedColumns = this.displayedColumns.concat(['leves_total', 'severas_total', 'defeitos_total', 'valores']);
        this.dataSource = new MatTableDataSource(passadas);

        this.enableTable = true;
    }

    async rebuildEstrategiaEsperada(): Promise<void> {

        // Estrategia Inicial
        await this.calcularEstrategiaInicial();
        this.passadasColunaColorOriginal = this.arrayPassadasEstrategiaInicial.length - 1;
        //await this.verificarSugestaoColunaColor();
        if (!this.isConditionalSite() && this.arrayPassadasEstrategiaInicial.length > 4
            || this.isConditionalSite() && this.arrayPassadasEstrategiaInicial.length > 3) {

        }
        else {
            this.passadasColunaColor = this.arrayPassadasEstrategiaInicial.length - 1;
            this.enableNumeroPassagens = true;

            // Teste numero de passadas com densimetrica
            await this.calcularEstrategiaDensimetrica();
            if (this.arrayPassadasEstrategiaFinal.length == 2 && this.arrayPassadasEstrategiaInicial.length > 3) {
                this.enableSugestaoDensimetrica = true;
                if (this.isConditionalSite())
                    this.enableSugestaoDensimetrica = false;
            }

            this.passadasDensimetrica = 0;
            this.passadasColunaColor = this.arrayPassadasEstrategiaInicial.length - 1;

            //this.textoPassadas = this.passadasColunaColor + ' passada(s) na coluna e color.';
        }

        if (this.arrayPassadasEstrategiaInicial.length <= 4) {
            //this.textoPassadas = (this.arrayPassadasEstrategiaInicial.length - 1) + ' passada(s) na coluna e color.';

            this.arrayPassadasTabela = this.arrayPassadasEstrategiaInicial;

            // Determinar focos Iniciais
            this.buscarDefeitoFoco(this.arrayPassadasEstrategiaInicial, this.numeroPassada, this.numeroPassada+1);
            //this.defeitosFoco = this.arrayPassadasEstrategiaInicial[0].campos_foco;
        }
        else {
            if (this.arrayPassadasEstrategiaInicial.length < this.arrayPassadasEstrategiaFinal.length) {
                //this.textoPassadas = (this.arrayPassadasEstrategiaInicial.length - 1) + ' passada(s) na coluna e color.';

                this.arrayPassadasTabela = this.arrayPassadasEstrategiaInicial;

                // Determinar focos Iniciais
                this.buscarDefeitoFoco(this.arrayPassadasEstrategiaInicial, this.numeroPassada, this.numeroPassada+1);
                //this.defeitosFoco = this.arrayPassadasEstrategiaInicial[0].campos_foco;

            }
            else {
                this.arrayPassadasTabela = this.arrayPassadasEstrategiaFinal;

                // Determinar focos Iniciais
                this.buscarDefeitoFoco(this.arrayPassadasEstrategiaFinal, this.numeroPassada, this.numeroPassada+1);
                //this.defeitosFoco = this.arrayPassadasEstrategiaFinal[0].campos_foco;

                if (this.isConditionalSite()) {
                    if (this.arrayPassadasEstrategiaFinal.length > 2) {
                        if (this.arrayPassadasEstrategiaFinal[1].passadaConditional === this.arrayPassadasEstrategiaFinal[2].passadaConditional)
                            this.defeitosFoco = this.arrayPassadasEstrategiaFinal[0].campos_foco.concat(this.arrayPassadasEstrategiaFinal[1].campos_foco);
                    }
                }
            }
        }
    }

    async buildEstrategiaFutura(objPassadaAtual: any): Promise<Array<any>> {

        // Estrategia Inicial
        var estrategiaInicial = [];
        estrategiaInicial.push(Object.assign({}, objPassadaAtual));

        var estrategiaTabela = [];

        // Calcula Estrategia apenas com Color Coluna
        var defeitosAtendemEsperado = false;
        var passadasNecessarias = 0;

        /*while (!defeitosAtendemEsperado) {
            // Buscar Porcentagens esperadas de Remocao
            await this.getPorcentagensRemocao(estrategiaInicial[passadasNecessarias], 'coluna_color');

            // Calcula Valores após a passada
            estrategiaInicial.push(await this.getValoresPosPassada(estrategiaInicial[passadasNecessarias], 'coluna_color'));

            passadasNecessarias++;

            if (estrategiaInicial[passadasNecessarias].severas_total <= 1
                && estrategiaInicial[passadasNecessarias].leves_total <= 3.5
                && estrategiaInicial[passadasNecessarias].defeitos_total <= 3.5)
                defeitosAtendemEsperado = true;

            if (passadasNecessarias > 5)
                defeitosAtendemEsperado = true;
        }*/
        var defeitosAtendemEsperado = false;
        var passadasNecessarias = 0;
        var sequencia = 1;
        var estrategiaFinal = [];

        while (!defeitosAtendemEsperado) {
            var estrategia = await this.verificarPassadas(estrategiaInicial[passadasNecessarias], sequencia);
            if (estrategia.length > 0){
                defeitosAtendemEsperado = true;
                estrategiaFinal = estrategia;
            }
            else
                sequencia++;
        }

		if (this.arrayPassadasEstrategiaInicial.length > 4) {
			defeitosAtendemEsperado = true;
		}

        //this.passadasColunaColorOriginal = estrategiaInicial.length - 1;
        await this.verificarSugestaoColunaColor();
        // Se possui mais de 3 Passadas calcula estrategia usando densimetrica
        // Estrategia Densimetrica
        var estrategiaDensimetrica = [];
        var estrategiaFinal = [];
        if (!this.isConditionalSite() && this.numeroPassada + estrategiaInicial.length > 4
            || this.isConditionalSite() && this.numeroPassada + estrategiaInicial.length > 3) {
            if (this.isConditionalSite())
                estrategiaFinal = await this.calcularEstrategiaDensimetricaFuturaConditional(Object.assign({}, objPassadaAtual));
            else {
                estrategiaFinal = await this.calcularEstrategiaDensimetricaFutura(Object.assign({}, objPassadaAtual));
            }
        }
        else {
            this.enableNumeroPassagens = true;

            // Teste numero de passadas com densimetrica
            estrategiaDensimetrica = await this.calcularEstrategiaDensimetricaFutura(Object.assign({}, objPassadaAtual));
            if (estrategiaDensimetrica.length == 2 && estrategiaInicial.length > 3) {
                this.enableSugestaoDensimetrica = true;
                if (this.isConditionalSite())
                    this.enableSugestaoDensimetrica = false;
            }

            this.passadasDensimetrica = 0;
            this.passadasColunaColor = estrategiaInicial.length - 1;

            //this.textoPassadas = this.passadasColunaColor + ' passada(s) na coluna e color.';
        }

        var numeroUltimaPassadaDensimetrica = 0;
        var numeroUltimaPassadaColunaColor = 0;

        if (this.isConditionalSite()) {
            if(estrategiaFinal.length > 0)
            {
                var passadaConditional = estrategiaFinal[0].numero_passada;
                estrategiaFinal.reduce((prev, curr) => {
                    if (prev.equip === 'Coluna e Color' && curr.equip === 'Densimétrica') {
                        prev['passadaConditional'] = passadaConditional;
                        curr['passadaConditional'] = passadaConditional;
                    }
                    else {
                        prev['passadaConditional'] = passadaConditional;
                        passadaConditional++;
                        curr['passadaConditional'] = passadaConditional;
                    }
                    return curr;
                })
                numeroUltimaPassadaDensimetrica = estrategiaFinal[estrategiaFinal.length - 1].passadaConditional;
            }
            numeroUltimaPassadaColunaColor = estrategiaInicial[estrategiaInicial.length - 1].numero_passada;
        }
        else {
            if(estrategiaFinal.length > 0)
                numeroUltimaPassadaDensimetrica = estrategiaFinal[estrategiaFinal.length - 1].numero_passada;
            numeroUltimaPassadaColunaColor = estrategiaInicial[estrategiaInicial.length - 1].numero_passada;
        }

        if (this.numeroPassada + numeroUltimaPassadaColunaColor <= 4 || numeroUltimaPassadaColunaColor <= numeroUltimaPassadaDensimetrica) {
            //this.textoPassadas = (estrategiaInicial.length - 1) + ' passada(s) na coluna e color.';

            estrategiaTabela = estrategiaInicial;

            // Determinar focos Iniciais
            this.buscarDefeitoFoco(estrategiaInicial, this.numeroPassada, this.numeroPassada+1);
            //this.defeitosFoco = estrategiaInicial[0].campos_foco;
        }
        else {
            var passadasInicial = estrategiaInicial[estrategiaInicial.length - 1].numero_passada;
            var passadasFinal = undefined;
            if (estrategiaFinal.length > 0) {
                passadasFinal = estrategiaFinal[estrategiaFinal.length - 1].numero_passada;

                if (this.isConditionalSite()) {
                    var passadaConditional = estrategiaFinal[0].numero_passada;
                    estrategiaFinal.reduce((prev, curr) => {
                        if (prev.equip === 'Coluna e Color' && curr.equip === 'Densimétrica') {
                            prev['passadaConditional'] = passadaConditional;
                            curr['passadaConditional'] = passadaConditional;
                        }
                        else {
                            prev['passadaConditional'] = passadaConditional;
                            passadaConditional++;
                            curr['passadaConditional'] = passadaConditional;
                        }
                        return curr;
                    })

                    passadasFinal = estrategiaFinal[estrategiaFinal.length - 1].passadaConditional;
                }
            }

            if ((!!passadasFinal && passadasInicial < passadasFinal) || passadasFinal === undefined) {
                //this.textoPassadas = passadasInicial + ' passada(s) na coluna e color.';

                estrategiaTabela = estrategiaInicial;

                // Determinar focos Iniciais
                this.buscarDefeitoFoco(estrategiaInicial, this.numeroPassada, this.numeroPassada+1);
                //this.defeitosFoco = estrategiaInicial[0].campos_foco;

            }
            else {
                estrategiaTabela = estrategiaFinal;

                // Determinar focos Iniciais
                this.buscarDefeitoFoco(estrategiaFinal, this.numeroPassada, this.numeroPassada+1);
                //this.defeitosFoco = estrategiaFinal[0].campos_foco;

                if (this.isConditionalSite()) {
                    if (estrategiaFinal.length > 2) {
                        if (estrategiaFinal[1].passadaConditional === estrategiaFinal[2].passadaConditional)
                            this.defeitosFoco = estrategiaFinal[0].campos_foco.concat(estrategiaFinal[1].campos_foco);
                    }
                }

            }
        }

        return estrategiaTabela;
    }

    async calcularEstrategiaDensimetricaFuturaConditional(objInicial: any): Promise<Array<any>> {
        var numeroDensimetrica = 1;
        var densimetricaAtende = false;

        var estrategiaFinal = [];
        estrategiaFinal.push(Object.assign({}, objInicial));

        while (!densimetricaAtende) {
            // Calcula Estrategia apenas com Color Coluna
            var defeitosAtendemEsperado = false;
            var defeitosNaoAtendemEsperado = false;
            var passadasNecessarias = 0;
            var numeroPassadas = 0;

            while (!defeitosAtendemEsperado && !defeitosNaoAtendemEsperado) {
                if (passadasNecessarias + 1 <= numeroDensimetrica) {
                    // Buscar Porcentagens esperadas de Remocao
                    await this.getPorcentagensRemocao(estrategiaFinal[numeroPassadas], 'coluna_color');

                    // Calcula Valores após a passada
                    estrategiaFinal.push(await this.getValoresPosPassada(estrategiaFinal[numeroPassadas], 'coluna_color'));

                    if (estrategiaFinal[numeroPassadas + 1].severas_total > 1
                        || estrategiaFinal[numeroPassadas + 1].leves_total > 3.5
                        || estrategiaFinal[numeroPassadas + 1].defeitos_total > 3.5) {
                        numeroPassadas++;
                        // Buscar Porcentagens esperadas de Remocao MGT
                        await this.getPorcentagensRemocaoDensimetrica(estrategiaFinal[numeroPassadas], 'densimetrica');

                        // Calcula Valores após a passada MGT
                        estrategiaFinal.push(await this.getValoresPosPassada(estrategiaFinal[numeroPassadas], 'densimetrica'));
                    }
                }
                else {
                    // Buscar Porcentagens esperadas de Remocao
                    await this.getPorcentagensRemocao(estrategiaFinal[numeroPassadas], 'coluna_color');

                    // Calcula Valores após a passada
                    estrategiaFinal.push(await this.getValoresPosPassada(estrategiaFinal[numeroPassadas], 'coluna_color'));
                }

                passadasNecessarias++;
                numeroPassadas++;

                if (estrategiaFinal[numeroPassadas].severas_total <= 1
                    && estrategiaFinal[numeroPassadas].leves_total <= 3.5
                    && estrategiaFinal[numeroPassadas].defeitos_total <= 3.5)
                    defeitosAtendemEsperado = true

                if (this.numeroPassada >= 3) {
                    if (passadasNecessarias >= 2) {
                        defeitosNaoAtendemEsperado = true;
                    }

                }
                else {
                    if (passadasNecessarias > 4) {
                        defeitosNaoAtendemEsperado = true;
                    }
                }
            }
            if ((passadasNecessarias <= 2 && defeitosAtendemEsperado) || (numeroDensimetrica === passadasNecessarias && defeitosAtendemEsperado)) {
                densimetricaAtende = true;

                this.passadasDensimetrica = estrategiaFinal.filter(x => x.equip === "Densimétrica" && x.tipo_passada == null).length;

                this.passadasColunaColor = estrategiaFinal.length - (numeroDensimetrica + 1);

                /*if (this.passadasColunaColor === 0)
                    this.textoPassadas = this.passadasDensimetrica + ' passada(s) na densimétrica';
                else
                    this.textoPassadas = this.passadasDensimetrica + ' passada(s) na densimétrica e ' + this.passadasColunaColor + ' passada(s) na coluna e color.';
                */
                this.enableNumeroPassagens = true;
            }
            else {
                // A partir do passe 3 (incluindo quando a passada for a terceira), limitar em no máximo 2 passes adicionais
                if (this.numeroPassada >= 3) {
                    if (numeroDensimetrica >= 2) {
                        densimetricaAtende = true;
                        //this.enableSugestaoMuitasPassadas = true;
                    }
                    else {
                        estrategiaFinal = [];
                        estrategiaFinal.push(Object.assign({}, objInicial));
                        numeroDensimetrica++;
                    }
                }
                else {
                    if (numeroDensimetrica > 4) {
                        densimetricaAtende = true;
                        //this.enableSugestaoMuitasPassadas = true;
                    }
                    else {
                        estrategiaFinal = [];
                        estrategiaFinal.push(Object.assign({}, objInicial));
                        numeroDensimetrica++;
                    }
                }
            }
        }

        return estrategiaFinal;
    }

    async calcularEstrategiaDensimetricaFutura(objInicial: any): Promise<Array<any>> {
        var numeroDensimetrica = 1;
        var densimetricaAtende = false;

        var estrategiaFinal = [];
        estrategiaFinal.push(Object.assign({}, objInicial));

        /*while (!densimetricaAtende) {
            // Calcula Estrategia apenas com Color Coluna
            var defeitosAtendemEsperado = false;
            var defeitosNaoAtendemEsperado = false;
            var passadasNecessarias = 0;

            while (!defeitosAtendemEsperado && !defeitosNaoAtendemEsperado) {
                if (passadasNecessarias + 1 <= numeroDensimetrica) {
                    // Buscar Porcentagens esperadas de Remocao MGT
                    await this.getPorcentagensRemocaoDensimetrica(estrategiaFinal[passadasNecessarias], 'densimetrica');

                    // Calcula Valores após a passada MGT
                    estrategiaFinal.push(await this.getValoresPosPassada(estrategiaFinal[passadasNecessarias], 'densimetrica'));
                }
                else {
                    // Buscar Porcentagens esperadas de Remocao
                    await this.getPorcentagensRemocao(estrategiaFinal[passadasNecessarias], 'coluna_color');

                    // Calcula Valores após a passada
                    estrategiaFinal.push(await this.getValoresPosPassada(estrategiaFinal[passadasNecessarias], 'coluna_color'));
                }

                passadasNecessarias++;

                if (estrategiaFinal[passadasNecessarias].severas_total <= 1
                    && estrategiaFinal[passadasNecessarias].leves_total <= 3.5
                    && estrategiaFinal[passadasNecessarias].defeitos_total <= 3.5)
                    defeitosAtendemEsperado = true

                if (this.numeroPassada >= 3) {
                    if (passadasNecessarias >= 2) {
                        defeitosNaoAtendemEsperado = true;
                    }

                }
                else {
                    if (passadasNecessarias > 4) {
                        defeitosNaoAtendemEsperado = true;
                    }

                }
            }

            if ((estrategiaFinal.length <= 4 && defeitosAtendemEsperado) || (numeroDensimetrica === passadasNecessarias && defeitosAtendemEsperado)) {
                densimetricaAtende = true;
                this.passadasDensimetrica = numeroDensimetrica;
                this.passadasColunaColor = estrategiaFinal.length - (numeroDensimetrica + 1);

                if (this.passadasColunaColor === 0)
                    this.textoPassadas = this.passadasDensimetrica + ' passada(s) na densimétrica';
                else
                    this.textoPassadas = this.passadasDensimetrica + ' passada(s) na densimétrica e ' + this.passadasColunaColor + ' passada(s) na coluna e color.';

                this.enableNumeroPassagens = true;
            }
            else {
                // A partir do passe 3 (incluindo quando a passada for a terceira), limitar em no máximo 2 passes adicionais
                if (this.numeroPassada >= 3) {
                    if (numeroDensimetrica >= 2) {
                        densimetricaAtende = true;
                        this.enableSugestaoMuitasPassadas = true;
                    }
                    else {
                        estrategiaFinal = [];
                        estrategiaFinal.push(Object.assign({}, objInicial));
                        numeroDensimetrica++;
                    }
                }
                else {
                    if (numeroDensimetrica > 4) {
                        densimetricaAtende = true;
                        this.enableSugestaoMuitasPassadas = true;
                    }
                    else {
                        estrategiaFinal = [];
                        estrategiaFinal.push(Object.assign({}, objInicial));
                        numeroDensimetrica++;
                    }
                }
            }
        }*/
        var defeitosAtendemEsperado = false;
        var passadasNecessarias = 0;
        var sequencia = 1;
        //var estrategiaFinal = [];

        while (!defeitosAtendemEsperado) {
            var estrategia = await this.verificarPassadas(estrategiaFinal[passadasNecessarias], sequencia);
            if (estrategia.length > 0){
                defeitosAtendemEsperado = true;
                estrategiaFinal = estrategia;
            }
            else
                sequencia++;
        }

		if (this.arrayPassadasEstrategiaInicial.length > 4) {
			defeitosAtendemEsperado = true;
		}

        //this.arrayPassadasEstrategiaFinal = estrategiaFinal;
        return estrategiaFinal;
    }

    async recalcularEstrategiaInicial(arrayPassadas: Array<any>): Promise<void> {
        // Calcula Estrategia apenas com Color Coluna
        var defeitosAtendemEsperado = false;
        var passadasNecessarias = 0;

        while (!defeitosAtendemEsperado) {
            // Buscar Porcentagens esperadas de Remocao
            await this.getPorcentagensRemocao(arrayPassadas[passadasNecessarias], 'coluna_color');

            // Calcula Valores após a passada
            arrayPassadas.push(await this.getValoresPosPassada(arrayPassadas[passadasNecessarias], 'coluna_color'));

            passadasNecessarias++;

            if (arrayPassadas[passadasNecessarias].severas_total <= 1
                && arrayPassadas[passadasNecessarias].leves_total <= 3.5
                && arrayPassadas[passadasNecessarias].defeitos_total <= 3.5)
                defeitosAtendemEsperado = true

            if (passadasNecessarias > 5) {
                defeitosAtendemEsperado = true;
            }
        }
    }

    async createFirstLineObject(): Promise<any> {

        //Cria Objeto
        var objPassada = {
            numero_passada: this.numeroPassada,
            quebradas_leves: this.quebradasLeves,
            quebradas_severas: this.quebradasSeveras,
            ardidas_leves: this.ardidasLeves,
            ardidas_severas: this.ardidasSeveras,
            furadas_leves: this.furadasLeves,
            furadas_severas: this.furadasSeveras,
            silk_cut_leves: this.silkCutLeves,
            silk_cut_severas: this.silkCutSeveras,
            popped_kernel_leves: this.poppedKernelLeves,
            popped_kernel_severas: this.poppedKernelSeveras,
            inerte_severas: this.inerte,
            defeitos_total: this.totalDefeitos
        }

        // Calcula total severas e leves
        var totalSeveras = 0;
        var totalLeves = 0;

        for (let key of Object.keys(objPassada)) {
            if (key.endsWith('severas') && !key.startsWith('inerte')) {
                if (!!objPassada[key]) {
                    totalSeveras += objPassada[key];
                }
            }
            if (key.endsWith('leves')) {
                if (!!objPassada[key]) {
                    totalLeves += objPassada[key];
                }
            }
        }

        objPassada['severas_total'] = totalSeveras;
        objPassada['leves_total'] = totalLeves;

        this.arrayPassadasEstrategiaInicial.push(Object.assign({}, objPassada));
        this.arrayPassadasEstrategiaFinal.push(Object.assign({}, objPassada));
        this.objetoPrimeiraPassada = Object.assign({}, objPassada);

        return objPassada;
    }

    getSelectedEquip(equip: string): Array<string> {
        var selectedEquip = [];

        switch (equip.trim()?.toUpperCase()) {
            case 'DENSIMÉTRICA'.trim()?.toUpperCase():
                selectedEquip.push('densimetrica')
                break;

            case 'COLUNA-COLOR1-DENSIMÉTRICA'.trim()?.toUpperCase():
            case 'COLUNA-COLOR2-DENSIMÉTRICA'.trim()?.toUpperCase():
                selectedEquip.push('coluna_color')
                selectedEquip.push('densimetrica')
                break;

            default:
                selectedEquip.push('coluna_color')
                break;
        }
        return selectedEquip;
    }

    comparaRealEsperadoByFoco(objEsperado: any, objReal: any, camposFoco: Array<any>): void {

        this.enableErrorExists = false;
        //Para cada campo foco
        camposFoco.forEach(foco => {
            const valorEsperado = objEsperado[foco.name];
            const valorReal = objReal[foco.name];

            //Se valor Real maior que esperado
            if (valorReal > valorEsperado) {
                this.enableErrorExists = true;
                switch (foco.equip) {
                    case 'Shape':
                        this.enableShapeText = true;
                        this.defeitoShapeText = 'inerte';

                        break;

                    case 'Color':
                        this.enableColorText = true;
                        this.defeitoColorText = foco.name.replace('_', ' ');

                        break;

                    case 'Coluna':
                        this.enableColunaText = true;
                        this.defeitoColunaText = foco.name.replace('_', ' ');

                        break;

                    case 'MGT':
                        this.enableMGTText = true;
                        this.defeitoMGTText = foco.name.replace('_', ' ');

                        break;
                    default:
                        break;
                }
            }

            //Caso tanha dica de densimetrica determina texto
            if (this.enableMGTText) {
                if (this.pesoHectolitricoFracaoBoa != null && this.pesoHectolitricoFracaoBoa != undefined && this.diferencaPesoHectolitrico != null && this.diferencaPesoHectolitrico != undefined) {
                    if (this.diferencaPesoHectolitrico < 5)
                        this.defeitoMGTDetails = 'e perda de sementes boas baixa. Ajustar o fluxo de ar na estratificação e/ou inclinação longitudinal.';
                    if (this.diferencaPesoHectolitrico >= 5 && this.diferencaPesoHectolitrico < 10)
                        this.defeitoMGTDetails = 'e perda de sementes boas intermediária. Ajustar a inclinação lateral e/ou vibração.';
                    if (this.diferencaPesoHectolitrico > 10)
                        this.defeitoMGTDetails = 'e perda de sementes boas alta. Ajustar a inclinação longitudinal e/ou alimentação (vazão).';
                }
                else {
                    this.defeitoMGTDetails = '. Preencher peso hectolítrico das frações boa e descarte para ter a recomendação de ajuste de regulagem.';
                }
            }
        });
    }

    changeTipoDefeito(event: any) {
        console.log(event.value);
    }

    isButtonDisabled() {
        const tipoFurado = this.formulario.get('tipo_furado')?.value;
        const tipoSilkCut = this.formulario.get('tipo_silk_cut')?.value;
        const tipoPoppedKernelSeveras = this.formulario.get('tipo_popped_kernel_severas')?.value;
        const tipoPoppedKernelLeves = this.formulario.get('tipo_popped_kernel_leves')?.value;

        if (((this.enableFuradasSeveras && tipoFurado != null) || !this.enableFuradasSeveras)
            && ((this.enableSilkCutSeveras && tipoSilkCut != null) || !this.enableSilkCutSeveras)
            && ((this.enablePoppedKernelSeveras && tipoPoppedKernelSeveras != null) || !this.enablePoppedKernelSeveras)
            && ((this.enablePoppedKernelLeves && tipoPoppedKernelLeves != null) || !this.enablePoppedKernelLeves))
            return false

        return true
    }

    formatOneDecimals(value: any): string {
        if (value != null) {
            if (isNaN(+value))
                return value;
            else
                return new Intl.NumberFormat('de-DE', { maximumFractionDigits: 1, minimumFractionDigits: 1 }).format(value);
        }
        else
            return ''
    }

    formatPassada(value: any): string {
        var field = 'numero_passada'
        if (this.isConditionalSite())
            field = 'passadaConditional'

        if (value[field] != null) {
            if (value[field] === 0)
                return 'Prévia'
            else
                return value[field] + 'º Passe';
        }
        else {
            if (value['numero_passada'] === 0)
                return 'Prévia'
            else
                return value['numero_passada'] + 'º Passe';
        }
    }

    formatCellText(value: any, columnName: string, isPrevia: boolean): string {
        var classStr = '';
        let defeitosFoco;

        if (!!value.campos_foco && value.campos_foco.length > 0) {
            /*if (!!value.campos_foco.find(x => x.name === columnName))
                classStr += 'color-lightcoral'*/
            if(value.numero_passada === 0) {
                if(this.arrayPassadasEstrategiaFinal[value.numero_passada+1] !== undefined && 
                    this.arrayPassadasEstrategiaFinal[value.numero_passada+1].equip.trim()?.toUpperCase() === "Densimétrica".trim()?.toUpperCase()){
                    defeitosFoco = value.campos_foco.filter(x => x.showEquip.trim()?.toUpperCase() === "Densimétrica".trim()?.toUpperCase());  
                } else {
                    defeitosFoco = value.campos_foco.filter(x => x.showEquip.trim()?.toUpperCase() !== "Densimétrica".trim()?.toUpperCase());
                }
                if (!!defeitosFoco.find(x => x.name === columnName))
                    classStr += 'color-lightcoral'
            }
            else if (!!value.campos_foco.find(x => x.name === columnName))
                classStr += 'color-lightcoral'
        }

        if (columnName === 'inerte_severas') {
            if (value[columnName] > 0)
                classStr += ' color-darkred'
        }

        if (isPrevia)
            return classStr;

        if (value['numero_passada'] != null && value[columnName] != null) {
            var valoresEsperados = this.arrayPassadasTabela.find(x => x.numero_passada === value['numero_passada']);

            if (!!valoresEsperados && (value.tipo_passada === 'real' || value.tipo_passada === 'atual')) {
                if (columnName === 'equip') {
                    if (valoresEsperados[columnName] !== value[columnName])
                        classStr += ' color-red'
                }
                else {
                    if (valoresEsperados[columnName] < value[columnName])
                        classStr += ' color-red'
                }
            }
        }

        return classStr;
    }

    formatCellTotal(value: any, columnName: string): string {
        var classStr = '';

        if (value[columnName] != null) {
            switch (columnName) {
                case 'severas_total':
                    if (value[columnName] <= 1)
                        classStr += 'color-green'
                    else
                        classStr += 'color-darkred'

                    break;

                case 'leves_total':
                    if (value[columnName] <= 3.5)
                        classStr += 'color-green'
                    else
                        classStr += 'color-darkred'

                    break;

                case 'defeitos_total':
                    if (value[columnName] <= 3.5)
                        classStr += 'color-green'
                    else
                        classStr += 'color-darkred'

                    break;
                default:
                    break;
            }
        }

        return classStr;
    }

    formatRowColor(value: any): string {
        if (value.tipo_passada !== null) {
            if (value.tipo_passada === 'real' || value.tipo_passada === 'atual')
                return 'color-lightgrey';
            else
                return '';
        }
        else
            return ''
    }

    getSeverasValuePrc(key: string, numeroPassada: number, equip: string, isFoco: boolean): any {
        var remocaoEsperada = {};

        const tipoFurado = this.formulario.get('tipo_furado')?.value;
        const tipoSilkCut = this.formulario.get('tipo_silk_cut')?.value;
        const tipoPoppedKernelSeveras = this.formulario.get('tipo_popped_kernel_severas')?.value;

        switch (key) {
            case 'furadas_severas':
                if (tipoFurado != null && tipoFurado != undefined) {
                    if (tipoFurado === "1") {
                        remocaoEsperada = this.listRemocaoDefeitosInfo.find(elem => elem.numero_passada === numeroPassada
                            && elem.tipo_defeito === 'severas'
                            && elem.nome_defeito === key.substring(0, key.lastIndexOf("_"))
                            && elem.foco === isFoco
                            && elem.equipamento === equip);
                    }
                    else {
                        remocaoEsperada = this.listRemocaoDefeitosInfo.find(elem => elem.numero_passada === numeroPassada
                            && elem.tipo_defeito === 'leves'
                            && elem.nome_defeito === key.substring(0, key.lastIndexOf("_"))
                            && elem.foco === false
                            && elem.equipamento === equip);
                    }
                }
                else {
                    remocaoEsperada = this.listRemocaoDefeitosInfo.find(elem => elem.numero_passada === numeroPassada
                        && elem.tipo_defeito === 'severas'
                        && elem.nome_defeito === key.substring(0, key.lastIndexOf("_"))
                        && elem.foco === isFoco
                        && elem.equipamento === equip);
                }

                break;

            case 'silk_cut_severas':
                if (tipoSilkCut != null && tipoSilkCut != undefined) {
                    if (tipoSilkCut === "1") {
                        remocaoEsperada = this.listRemocaoDefeitosInfo.find(elem => elem.numero_passada === numeroPassada
                            && elem.tipo_defeito === 'severas'
                            && elem.nome_defeito === key.substring(0, key.lastIndexOf("_"))
                            && elem.foco === isFoco
                            && elem.equipamento === equip);
                    }
                    else {
                        remocaoEsperada = this.listRemocaoDefeitosInfo.find(elem => elem.numero_passada === numeroPassada
                            && elem.tipo_defeito === 'leves'
                            && elem.nome_defeito === key.substring(0, key.lastIndexOf("_"))
                            && elem.foco === false
                            && elem.equipamento === equip);
                    }
                }
                else {
                    remocaoEsperada = this.listRemocaoDefeitosInfo.find(elem => elem.numero_passada === numeroPassada
                        && elem.tipo_defeito === 'severas'
                        && elem.nome_defeito === key.substring(0, key.lastIndexOf("_"))
                        && elem.foco === isFoco
                        && elem.equipamento === equip);
                }

                break;

            case 'popped_kernel_severas':
                if (tipoPoppedKernelSeveras != null && tipoPoppedKernelSeveras != undefined) {
                    if (tipoPoppedKernelSeveras === "0") {
                        remocaoEsperada = this.listRemocaoDefeitosInfo.find(elem => elem.numero_passada === numeroPassada
                            && elem.tipo_defeito === 'severas_densidade'
                            && elem.nome_defeito === key.substring(0, key.lastIndexOf("_"))
                            && elem.foco === isFoco
                            && elem.equipamento === equip);
                    }
                    else if (tipoPoppedKernelSeveras === "1") {
                        remocaoEsperada = this.listRemocaoDefeitosInfo.find(elem => elem.numero_passada === numeroPassada
                            && elem.tipo_defeito === 'severas_cor'
                            && elem.nome_defeito === key.substring(0, key.lastIndexOf("_"))
                            && elem.foco === isFoco
                            && elem.equipamento === equip);
                    }
                }
                else {
                    remocaoEsperada = this.listRemocaoDefeitosInfo.find(elem => elem.numero_passada === numeroPassada
                        && elem.tipo_defeito === 'severas'
                        && elem.nome_defeito === key.substring(0, key.lastIndexOf("_"))
                        && elem.foco === isFoco
                        && elem.equipamento === equip);
                }

                break;

            default:
                remocaoEsperada = this.listRemocaoDefeitosInfo.find(elem => elem.numero_passada === numeroPassada
                    && elem.tipo_defeito === 'severas'
                    && elem.nome_defeito === key.substring(0, key.lastIndexOf("_"))
                    && elem.foco === isFoco
                    && elem.equipamento === equip);

                break;
        }

        return remocaoEsperada;
    }

    getLevesValuePrc(key: string, numeroPassada: number, equip: string, isFoco: boolean): any {
        var remocaoEsperada = {};

        const tipoPoppedKernelLeves = this.formulario.get('tipo_popped_kernel_leves')?.value;

        switch (key) {
            case 'popped_kernel_leves':
                if (tipoPoppedKernelLeves != null && tipoPoppedKernelLeves != undefined) {
                    if (tipoPoppedKernelLeves === "0") {
                        remocaoEsperada = this.listRemocaoDefeitosInfo.find(elem => elem.numero_passada === numeroPassada
                            && elem.tipo_defeito === 'leves'
                            && elem.nome_defeito === key.substring(0, key.lastIndexOf("_"))
                            && elem.foco === isFoco
                            && elem.equipamento === equip);
                    }
                    else if (tipoPoppedKernelLeves === "1") {
                        remocaoEsperada = this.listRemocaoDefeitosInfo.find(elem => elem.numero_passada === numeroPassada
                            && elem.tipo_defeito === 'leves_cor'
                            && elem.nome_defeito === key.substring(0, key.lastIndexOf("_"))
                            && elem.foco === isFoco
                            && elem.equipamento === equip);
                    }
                }
                else {
                    remocaoEsperada = this.listRemocaoDefeitosInfo.find(elem => elem.numero_passada === numeroPassada
                        && elem.tipo_defeito === 'leves'
                        && elem.nome_defeito === key.substring(0, key.lastIndexOf("_"))
                        && elem.foco === isFoco
                        && elem.equipamento === equip);
                }

                break;

            default:
                remocaoEsperada = this.listRemocaoDefeitosInfo.find(elem => elem.numero_passada === numeroPassada
                    && elem.tipo_defeito === 'leves'
                    && elem.nome_defeito === key.substring(0, key.lastIndexOf("_"))
                    && elem.foco === isFoco
                    && elem.equipamento === equip);

                break;
        }

        return remocaoEsperada;
    }

    getAverage(field: string, array: Array<any>): number {
        return array.reduce((total, next) => total + next[field], 0) / array.length;
    }

    getTipoPassada(value: any): string {
        if (!!value) {
            if (value === 'real')
                return 'Realizado';
            else {
                if (value === 'atual')
                    return 'Em Andamento';
                else
                    return 'Objetivo';
            }
        }
        else
            return 'Objetivo'
    }

    getAlertaRangesPerdaSementesBoas(): void {
        if(this.equipamentosUtilizados.trim()?.toUpperCase() == "Coluna-Color1".trim()?.toUpperCase() && this.perdaBoaPrc > 4 || 
            this.equipamentosUtilizados.trim()?.toUpperCase() == "Densimétrica".trim()?.toUpperCase() && this.perdaBoaPrc > 7)
            this.isPerdaSementesBoas = true;
    }

    getAlertaDiferencaPesoHectolitrico(): void {
        if (this.equipamentosUtilizados.trim()?.toUpperCase() == "Densimétrica".trim()?.toUpperCase() && this.numeroPassada !== 0) {
            if (this.pesoHectolitricoFracaoBoa != null && this.pesoHectolitricoFracaoBoa != undefined && 
                this.diferencaPesoHectolitrico != null && this.diferencaPesoHectolitrico != undefined && this.passadaAnteriorPrevia != "prévia") {
                if (this.diferencaPesoHectolitrico < 5) {
                    this.defeitoMGTDetails = 'e perda de sementes boas baixa. Ajustar o fluxo de ar na estratificação e/ou inclinação longitudinal.';
                    this.isDefeitoMGTDetails = true;
                }            
                if (this.diferencaPesoHectolitrico >= 5 && this.diferencaPesoHectolitrico < 10) {
                    this.defeitoMGTDetails = 'e perda de sementes boas intermediária. Ajustar a inclinação lateral e/ou vibração.';
                    this.isDefeitoMGTDetails = true;
                }              
                if (this.diferencaPesoHectolitrico > 10) {
                    this.defeitoMGTDetails = 'e perda de sementes boas alta. Ajustar a inclinação longitudinal e/ou alimentação (vazão).';
                    this.isDefeitoMGTDetails = true;
                }          
            }
            else if (this.pesoHectolitricoFracaoBoa != null && this.pesoHectolitricoFracaoBoa != undefined && 
                this.diferencaPesoHectolitrico != null && this.diferencaPesoHectolitrico != undefined && this.passadaAnteriorPrevia == "prévia") {
                    if (this.diferencaPesoHectolitrico < 5) {
                        this.defeitoMGTDetails = 'Perda de sementes boas baixa. Ajustar o fluxo de ar na estratificação e/ou inclinação longitudinal.';
                        this.isDefeitoMGTDetailsPrevia = true;
                    }            
                    if (this.diferencaPesoHectolitrico >= 5 && this.diferencaPesoHectolitrico < 10) {
                        this.defeitoMGTDetails = 'Perda de sementes boas intermediária. Ajustar a inclinação lateral e/ou vibração.';
                        this.isDefeitoMGTDetailsPrevia = true;
                    }              
                    if (this.diferencaPesoHectolitrico > 10) {
                        this.defeitoMGTDetails = 'Perda de sementes boas alta. Ajustar a inclinação longitudinal e/ou alimentação (vazão).';
                        this.isDefeitoMGTDetailsPrevia = true;
                    }  
                }
            else {
                this.defeitoMGTDetails = '. Preencher peso hectolítrico das frações boa e descarte para ter a recomendação de ajuste de regulagem.';
            }
        }
    }

    verificarAprovacao(obj: any): boolean {
        var defeitosAtendemEsperado = false;

        if (obj.severas_total <= 1.5
            && obj.leves_total <= 3.5
            && obj.defeitos_total <= 3.5)
            defeitosAtendemEsperado = true;

        return defeitosAtendemEsperado;
    }

    async buscarValoresEquipamentoPassada(estrategiaFinal: Array<any>, passada: number, equipamento: string): Promise<any[]> {
        equipamento === 'coluna_color' ? await this.getPorcentagensRemocao(estrategiaFinal[passada], equipamento) :
            await this.getPorcentagensRemocaoDensimetrica(estrategiaFinal[passada], equipamento);

        var valores = await this.getValoresPosPassada(estrategiaFinal[passada], equipamento);

        return valores;
    }

    getAcoesPassadaAprovada(estrategiaFinal: Array<any>): void {
        this.arrayPassadasEstrategiaInicial = estrategiaFinal;
        this.arrayPassadasEstrategiaFinal = estrategiaFinal;
        this.enableNumeroPassagens = true;
        this.enableSugestaoIneficiente = false;
    }

    getAcoesPassadaReprovada(): void {
        this.enableSugestaoIneficiente = true;
        this.enableNumeroPassagens = false;
    }

    async verificarPassadas(objInicial: Array<any>, sequencia: number): Promise<any[]> {
        var estrategiaFinal = [];
        estrategiaFinal.push(Object.assign({}, objInicial));

        if (sequencia === 1) {
            var valores = await this.buscarValoresEquipamentoPassada(estrategiaFinal, 0, 'coluna_color');

            this.densimetricaPresente = false;
            var aprovado = this.verificarAprovacao(valores);
     
            if (aprovado) {
                estrategiaFinal.push(valores);
                this.getAcoesPassadaAprovada(estrategiaFinal);
                this.textoPassadas = '1 passada na coluna e color.';
                return estrategiaFinal;
            }       
            else {
                this.getAcoesPassadaReprovada();
                return [];
            }          
        }
        else if (sequencia === 2) {
            for(var i = 0; i < 2; i++) {
                var valores = await this.buscarValoresEquipamentoPassada(estrategiaFinal, i, 'coluna_color');
                
                this.densimetricaPresente = false;
                var aprovado = this.verificarAprovacao(valores);     

                if (aprovado) {
                    estrategiaFinal.push(valores);
                    this.getAcoesPassadaAprovada(estrategiaFinal);
                    i === 0 ? this.textoPassadas = '1 passada na coluna e color.' : this.textoPassadas = '2 passadas na coluna e color.';
                    return estrategiaFinal;
                }       
                else {
                    if(i === 0)
                        estrategiaFinal.push(valores);
                    else {
                        this.getAcoesPassadaReprovada();
                        return [];
                    }                       
                }
            }
        }
        else if (sequencia === 3) {
            var valores = await this.buscarValoresEquipamentoPassada(estrategiaFinal, 0, 'densimetrica');

            this.densimetricaPresente = true;
            var aprovado = this.verificarAprovacao(valores);
     
            if (aprovado) {
                estrategiaFinal.push(valores);
                this.getAcoesPassadaAprovada(estrategiaFinal);
                this.textoPassadas = '1 passada na densimétrica.';
                return estrategiaFinal;
            }       
            else {
                this.getAcoesPassadaReprovada();
                return [];
            }
        }
        else if (sequencia === 4) {
            for(var i = 0; i < 2; i++) {
                if(i === 0)      
                    valores = await this.buscarValoresEquipamentoPassada(estrategiaFinal, i, 'densimetrica');
                else if(i === 1)
                    valores = await this.buscarValoresEquipamentoPassada(estrategiaFinal, i, 'coluna_color');

                this.densimetricaPresente = true;
                var aprovado = this.verificarAprovacao(valores);

                if (aprovado) {
                    estrategiaFinal.push(valores);
                    this.getAcoesPassadaAprovada(estrategiaFinal);
                    i === 0 ? this.textoPassadas = '1 passada na densimétrica.' : this.textoPassadas = '1 passada na densimétrica e 1 passada na coluna e color.';
                    return estrategiaFinal;
                }       
                else {
                    if(i === 0)
                        estrategiaFinal.push(valores);
                    else {
                        this.getAcoesPassadaReprovada();
                        return [];
                    }       
                }
            }
        }
        else if (sequencia === 5) {
            for(var i = 0; i < 3; i++) {
                var valores = await this.buscarValoresEquipamentoPassada(estrategiaFinal, i, 'coluna_color');
  
                this.densimetricaPresente = false;
                var aprovado = this.verificarAprovacao(valores);

                if (aprovado) {
                    estrategiaFinal.push(valores);
                    this.getAcoesPassadaAprovada(estrategiaFinal);
                    if (i === 0)
                        this.textoPassadas = '1 passada na coluna e color.';
                    else if (i === 1)
                        this.textoPassadas = '2 passadas na coluna e color.';
                    else if (i === 2)
                        this.textoPassadas = '3 passadas na coluna e color.';
                    return estrategiaFinal;
                }       
                else {
                    if(i < 2)
                        estrategiaFinal.push(valores);
                    else {
                        this.getAcoesPassadaReprovada();
                        return [];
                    }                  
                }
            }
        }
        else if (sequencia === 6) {
            for(var i = 0; i < 2; i++) {
                var valores = await this.buscarValoresEquipamentoPassada(estrategiaFinal, i, 'densimetrica');

                this.densimetricaPresente = true;
                var aprovado = this.verificarAprovacao(valores);

                if (aprovado) {
                    estrategiaFinal.push(valores);
                    this.getAcoesPassadaAprovada(estrategiaFinal);
                    i === 0 ? this.textoPassadas = '1 passada na densimétrica.' : this.textoPassadas = '2 passadas na densimétrica';
                    return estrategiaFinal;
                }       
                else {
                    if(i === 0)
                        estrategiaFinal.push(valores);
                    else {
                        this.getAcoesPassadaReprovada();
                        return [];
                    }                  
                }
            }
        }
        else if (sequencia === 7) {
            for(var i = 0; i < 3; i++) {
                if(i === 0)              
                    var valores = await this.buscarValoresEquipamentoPassada(estrategiaFinal, i, 'densimetrica');
                else if(i === 1) 
                    var valores = await this.buscarValoresEquipamentoPassada(estrategiaFinal, i, 'densimetrica');
                else if(i === 2) 
                    var valores = await this.buscarValoresEquipamentoPassada(estrategiaFinal, i, 'coluna_color');

                this.densimetricaPresente = true;
                var aprovado = this.verificarAprovacao(valores);

                if (aprovado) {
                    estrategiaFinal.push(valores);
                    this.getAcoesPassadaAprovada(estrategiaFinal);
                    if (i === 0)
                        this.textoPassadas = '1 passada na densimétrica.';
                    else if (i === 1)
                        this.textoPassadas = '2 passadas na densimétrica.';
                    else if (i === 2)
                        this.textoPassadas = '2 passadas na densimétrica e 1 passada na coluna e color.';
                    return estrategiaFinal;
                }       
                else {
                    if(i < 2)
                        estrategiaFinal.push(valores);
                    else {
                        this.getAcoesPassadaReprovada();
                        return [];
                    }                
                }
            }
        }
        else if (sequencia === 8) {
            for(var i = 0; i < 3; i++) {
                var valores = await this.buscarValoresEquipamentoPassada(estrategiaFinal, i, 'densimetrica');

                this.densimetricaPresente = true;
                var aprovado = this.verificarAprovacao(valores);

                if (aprovado) {
                    estrategiaFinal.push(valores);
                    this.getAcoesPassadaAprovada(estrategiaFinal);
                    if (i === 0)
                        this.textoPassadas = '1 passada na densimétrica.';
                    else if (i === 1)
                        this.textoPassadas = '2 passadas na densimétrica.';
                    else if (i === 2)
                        this.textoPassadas = '3 passadas na densimétrica.';
                    return estrategiaFinal;
                }       
                else {
                    if(i < 2)
                        estrategiaFinal.push(valores);
                    else {
                        this.getAcoesPassadaReprovada();
                        return [];
                    }              
                }
            }
        }
        else if (sequencia === 9) {
            for(var i = 0; i < 4; i++) {
                if(i === 0)              
                    var valores = await this.buscarValoresEquipamentoPassada(estrategiaFinal, i, 'densimetrica');
                else if(i === 1) 
                    var valores = await this.buscarValoresEquipamentoPassada(estrategiaFinal, i, 'densimetrica');
                else if(i === 2) 
                    var valores = await this.buscarValoresEquipamentoPassada(estrategiaFinal, i, 'coluna_color');
                else if(i === 3) 
                    var valores = await this.buscarValoresEquipamentoPassada(estrategiaFinal, i, 'coluna_color');

                this.densimetricaPresente = true;
                var aprovado = this.verificarAprovacao(valores);

                if (aprovado) {
                    estrategiaFinal.push(valores);
                    this.getAcoesPassadaAprovada(estrategiaFinal);
                    if (i === 0)
                        this.textoPassadas = '1 passada na densimétrica.';
                    else if (i === 1)
                        this.textoPassadas = '2 passadas na densimétrica.';
                    else if (i === 2)
                        this.textoPassadas = '2 passadas na densimétrica e 1 passada na coluna e color.';
                    else if (i === 3)
                        this.textoPassadas = '2 passadas na densimétrica e 2 passadas na coluna e color.';
                    return estrategiaFinal;
                }       
                else {
                    if(i < 3)
                        estrategiaFinal.push(valores);
                    else {
                        this.getAcoesPassadaReprovada();
                        return [];
                    }                  
                }
            }
        }
        else if (sequencia === 10) {
            for(var i = 0; i < 4; i++) {
                if(i === 0)
                    var valores = await this.buscarValoresEquipamentoPassada(estrategiaFinal, i, 'densimetrica');
                else if(i === 1) 
                    var valores = await this.buscarValoresEquipamentoPassada(estrategiaFinal, i, 'densimetrica');
                else if(i === 2) 
                    var valores = await this.buscarValoresEquipamentoPassada(estrategiaFinal, i, 'densimetrica');
                else if(i === 3) 
                    var valores = await this.buscarValoresEquipamentoPassada(estrategiaFinal, i, 'coluna_color');

                this.densimetricaPresente = true;
                var aprovado = this.verificarAprovacao(valores);

                if (aprovado) {
                    estrategiaFinal.push(valores);
                    this.getAcoesPassadaAprovada(estrategiaFinal);
                    if (i === 0)
                        this.textoPassadas = '1 passada na densimétrica.';
                    else if (i === 1)
                        this.textoPassadas = '2 passadas na densimétrica.';
                    else if (i === 2)
                        this.textoPassadas = '3 passadas na densimétrica.';
                    else if (i === 3)
                        this.textoPassadas = '3 passadas na densimétrica e 1 passada na coluna e color.';
                    return estrategiaFinal;
                }       
                else {
                    if(i <= 3)
                    {
                        estrategiaFinal.push(valores);           
                        this.getAcoesPassadaReprovada();
                        this.arrayPassadasEstrategiaInicial = estrategiaFinal;
                        this.arrayPassadasEstrategiaFinal = estrategiaFinal;
                    } 
                }
            }
        }

        return estrategiaFinal;
    }

    async verificarSugestaoColunaColor(): Promise<void> {
        var defeitosAtendemEsperado = false;
        var numeroPassadas = 0;
        var passadasColunaColor = [];
        var valores = [];
        var sugestaoColunaColor = this.arrayPassadasEstrategiaFinal.filter(x => x.equip === "Densimétrica" && x.tipo_passada !== "real").length;

        if (sugestaoColunaColor > 0) {
            while (!defeitosAtendemEsperado) {
                if(passadasColunaColor.length == 0)
                    var valores = await this.buscarValoresEquipamentoPassada(this.arrayPassadasEstrategiaFinal, numeroPassadas, 'coluna_color');
                else      
                    var valores = await this.buscarValoresEquipamentoPassada(passadasColunaColor, numeroPassadas - 1, 'coluna_color');

                var aprovado = this.verificarAprovacao(valores);

                if (aprovado) {
                    defeitosAtendemEsperado = true;
                    this.passadasColunaColorOriginal;
                    this.enableSugestaoColunaColor = true;
                    this.enableSugestaoMuitasPassadas = false;
                }       
                else {
                    defeitosAtendemEsperado = false;
                    numeroPassadas++;
                    passadasColunaColor.push(valores);   
                }
                this.passadasColunaColorOriginal++;   
            }
        }
        else
            this.enableSugestaoColunaColor = false;
    }
}
